<template>
    <div id="deviceList">
        <!-- 标题 -->
        <div class="breadcrumb">
            <span class="c-pointer" v-show="!breadcrumbShow">设备列表</span><span class="c-pointer" v-show="breadcrumbShow" @click="tolist"><img :src="back"> {{isFictitious?'查看扩展属性':editDeviceShow?nowObj.name:' '}}</span>
        </div>
        <!-- 支线 -->
        <div class=""> <!-- @setTree="setTree" -->
            <tree @changenode="treeClick" :companyId='companyId'></tree>
        </div>
        <div class="content-box height-1 left-313" v-show="isList">
            <header class="top">
                <el-button type="primary" class="add-btn" @click="operate('addDeviceShow')" :disabled="!$store.state.functionList.includes('companyServiceDevice')||$store.state.isLook">新建设备</el-button>   <!--  -->
                <el-button type="primary" class="add-btn" @click="showCheck=!showCheck;checkObj=[]" :disabled="!$store.state.functionList.includes('companyServiceDevice')||$store.state.isLook">{{!showCheck?'选择':'取消'}}</el-button>   <!--  -->
                <el-button type="primary" class="add-btn" @click="editGroupShow=true,$store.state.mask=true" v-show="showCheck" :disabled="!$store.state.functionList.includes('companyServiceDevice')||$store.state.isLook||!checkObj.length">修改分组</el-button>   <!--  -->
                <el-button v-if="cssType==1" type="primary" class="px-btn f-r" @click="paixu" :disabled="!$store.state.functionList.includes('companyServiceDevice')||$store.state.isLook" icon="el-icon-s-operation"></el-button>
                <div class="f-r">
                    <div class="search-btn">
                        <el-button type="primary" class="add-btn" @click="searchAttr">搜索</el-button>
                    </div>
                    <div class="search w-250">
                        <el-input
                            placeholder="请输入设备名称或key"
                            v-model="searchAttrVal" class="search-input " @keyup.enter.native="searchAttr">
                            <i slot="suffix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                    </div>
                </div>
            </header>
            <div class="list-box" style="height: 95%;">
                <ul class="list-title" style="width: 99%; margin-left: 0;">
                    <li>设备名称</li>
                    <li>key</li>
                    <li class="w-90">设备状态</li>
                    <li class="w-18">添加时间</li>
                    <li class="w-18">备注</li>
                    <li>操作</li>
                </ul>
                <div class="scroll scroll2">
                  <el-checkbox-group v-model="checkObj" @change="changeCheck">
                    <ul class="list-details fictitious" v-show="treeId==0 && treeType == 1">
                        <li>虚拟设备</li>
                        <li :title="VirtualDevice.code">{{VirtualDevice.code}}</li>
                        <li class="w-90">无</li>
                        <li class="w-18" >{{changeTime(VirtualDevice.createdTime)}}</li>
                        <li :title="VirtualDevice.note" class="w-18 note">{{VirtualDevice.note}}</li>
                        <li class="operate">
                            <span @click="seeFictitious">{{$store.state.functionList.includes('companyServiceDevice')&&!$store.state.isLook?'编辑':'查看'}}</span>
                            <span @click="nowDataVirtualDevice(VirtualDevice)">实时数据</span>
                        </li>
                    </ul>
                    <div v-for="(device,d) in list" :key="device.code" v-show="showCodeArr.includes(device.code)">
                      <ul class="list-details" v-if="device.type!=1">
                          <el-checkbox :label="device.code" style="margin-left: 10px;" v-show="showCheck">{{''}}</el-checkbox>
                          <li :title="device.name" :style="{'margin-left':showCheck?'0':null}">{{device.name}}</li>
                          <li :title="device.code">{{device.code}}</li>
                          <li class="w-90" :class="{'color-red':device.state == 2||device.state == 4}">{{deviceState(device.state)}}</li>
                          <li :title="changeTime(device.createdTime)" class="w-18">{{changeTime(device.createdTime)}}</li>
                          <li :title="device.note" class="w-18">{{device.note}}</li>
                          <li class="operate">
                              <span @click="seeDevice(device,d)">{{$store.state.functionList.includes('companyServiceDevice')&&!$store.state.isLook?'编辑':'查看'}}</span>
                              <span :class="{'disabled':!$store.state.functionList.includes('companyServiceDevice')||$store.state.isLook}" @click="operate('delDeviceShow',device,d)">删除</span>
                              <span :class="{'disabled':!$store.state.functionList.includes('companyServiceDevice')||$store.state.isLook}" v-if="device.state == 4" @click="operate('enableDeviceShow',device,d)">启用</span>
                              <span :class="{'disabled':!$store.state.functionList.includes('companyServiceDevice')||$store.state.isLook}" v-if="device.state == 1" @click="operate('disDeviceShow',device,d)">停用</span>
                              <span @click="nowDataClick(device)">实时数据</span>
                          </li>
                      </ul>
                    </div>
                  </el-checkbox-group>
                </div>
            </div>
        </div>
        <!-- 查看扩展属性 -->
        <div class="content-box height-2" v-show="isFictitious">
            <header class="top">
                <el-button type="primary" class="add-btn" @click="operate('addExtendShow')" :disabled="!$store.state.functionList.includes('companyServiceDevice')||$store.state.isLook">新建扩展属性</el-button>
            </header>
            <div class="list-box" style="height: 95%;">
                <div class="scroll scroll2">
                    <ul class="list-title">
                        <li>属性名称</li>
                        <li class="w-90">函数</li>
                        <li class="w-18">操作</li>
                        <li class="w-26"></li>
                        <li class="w-26"></li>
                        <li class="w-26"></li>
                    </ul>
                    <ul class="list-details" v-for="(virtual,v) in VirtualFuncList" :key="v">
                        <li :title="virtual.name">{{virtual.name}}</li>
                        <li class="w-90">{{getFunc(virtual.function)}}</li>
                        <li class="operate w-18">
                            <span @click="editExtend(virtual,v)">{{$store.state.functionList.includes('companyServiceDevice')&&!$store.state.isLook?'编辑':'查看'}}</span>
                            <span :class="{'disabled':!$store.state.functionList.includes('companyServiceDevice')||$store.state.isLook}" @click="operate('delAttributeShow',virtual,v)">删除</span>
                        </li>
                        <li class="w-26"></li>
                        <li class="w-26"></li>
                        <li class="w-26"></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="content-box height-3 top-0" v-show="editDeviceShow">
            <div class="bg" style="height: 100%;">
                <div class="edit-top clearfix">
                    <!-- <p>关联产品：<el-cascader :options="productData" :show-all-levels="false" :props="optionProps" v-model="ruleForm.productId" class="cascader "></el-cascader></p> -->
                    <p class="m-r-48">key：{{nowObj.code}} <span class="copy" @click="copy('copycode')">复制</span></p>
                    <p class="m-r-48">设备密钥：{{nowObj.secret}}<span class="copy" @click="copy('copysecret')">复制</span></p>
                    <textarea class="copy-obj" ref="copycode">{{nowObj.code}}</textarea>
                    <textarea class="copy-obj" ref="copysecret">{{nowObj.secret}}</textarea>
                </div>
                <!-- <div class="p-select"><span @click="operate('selectAttrShow')">选择属性</span><span @click="operate('selectWarnShow')">选择报警</span></div> -->
                <div class="edit-btn-box">
                    <div :class="{'active':active==0}" @click="setActive(0)"><span class="border-0">设备信息</span></div>
                    <div :class="{'active':active==1}" @click="setActive(1)"><span>设备日志</span></div>
                    <div :class="{'active':active==2}" @click="setActive(2)"><span>维保记录</span></div>
                </div>
                <div class="search-box f-r" v-show="active==1">
                    <div class="time-box f-l">
                        <span>时间：</span>
                        <el-date-picker
                            v-model="beginDate"
                            :editable="false"
                            type="date"
                            class="time m-r-12"
                            placeholder="选择日期"
                            format="yyyy-MM-dd"
                            :picker-options="pickerOptionsStart"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                        <span>至</span>
                        <el-date-picker
                            v-model="endDate"
                            :editable="false"
                            type="date"
                            class="time"
                            placeholder="选择日期"
                            :picker-options="pickerOptionsEnd"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </div>
                    <div class="f-r w-40">
                        <div class="f-r w-20 m-r-12">
                            <el-button type="primary" class="add-btn" @click="getDeviceLog">搜索</el-button>
                        </div>
                        <div class="search w-288">
                            <el-input
                                placeholder="请输入事件名称或操作人"
                                v-model="searchVal" class="search-input" @keyup.enter.native="getDeviceLog">
                                <i slot="suffix" class="el-input__icon el-icon-search"></i>
                            </el-input>
                        </div>
                    </div>
                </div>
                <div class="pro-details" v-show="active==0">
                    <p class="details-p">基本信息<span @click="setDevice">{{$store.state.functionList.includes('companyServiceDevice')&&!$store.state.isLook?'编辑':'查看'}}</span></p> <!--"-->
                    <div class="details clearfix">
                        <div class="clearfix">
                            <span class="lab-title border-b">设备名称</span>
                            <span class="w-21 border-b">{{nowObj.name}}</span>
                            <span class="lab-title border-b">设备状态</span>
                            <span class="w-22 border-b" :class="{'color-red':nowObj.state == 2||nowObj.state == 4}">{{deviceState(nowObj.state)}}</span>
                            <span class="lab-title border-b">创建时间</span>
                            <span class="w-33 border-b">{{changeTime(nowObj.createdTime)}}</span>
                        </div>
                        <div>
                            <span class="lab-title">备注</span>
                            <span class="lab-note">{{nowObj.note}}</span>
                        </div>
                    </div>
                    <p class="details-p" v-if="nowObj.extInfo">扩展信息</p> <!--"-->
                    <div class="details clearfix" v-if="nowObj.extInfo">
                        <div class="clearfix">
                            <span class="lab-title border-b">扩展设备名称</span>
                            <span class="w-21 border-b">{{nowObj.extInfo.name}}</span>
                            <span class="lab-title border-b">序列号</span>
                            <span class="w-22 border-b">{{nowObj.extInfo.serialNo}}</span>
                            <span class="lab-title border-b">扩展设备key</span>
                            <span class="w-33 border-b">{{nowObj.extInfo.equipmentKey}}</span>
                        </div>
                        <div>
                            <span class="lab-title">规格参数</span>
                            <div class="lab-note">
                                <span v-for="item,i in nowObj.extInfo.specsParam" :key="i" style="margin-right: 8px;">{{ item.title }}:{{ item.content }};</span>
                            </div>
                        </div>
                    </div>
                    <p class="details-p" v-if="nowObj.extInfo">相关图片及视频</p>
                    <div class="detail-media-grid" v-if="nowObj.extInfo">
                        <div v-for="(item, index) in getExtMediaList(nowObj.extInfo.fileUrl)" :key="item.uid || index"
                             class="detail-media-item detail-media-clickable" @click="openExtMediaPreview(item)">
                            <img v-if="isExtImage(item)" :src="buildExtMediaUrl(item.url)" :alt="item.name">
                            <video v-else-if="isExtVideo(item)" :src="buildExtMediaUrl(item.url)" muted preload="metadata"></video>
                            <i v-else class="el-icon-document"></i>
                            <span v-if="isExtVideo(item)" class="detail-video-play"><i class="el-icon-video-play"></i></span>
                        </div>
                        <div v-if="getExtMediaList(nowObj.extInfo.fileUrl).length === 0" class="detail-media-empty">暂无相关图片及视频</div>
                    </div>

                    <!-- <p class="btn-box b-128"><el-button type="primary" @click="editDevice">确定</el-button><el-button @click="tolist">取消</el-button></p> -->
                </div>
                <div v-show="active==1" style="height: 75%">
                    <div class="clearfix" style="height: 100%">
                        <ul class="list-title" style="margin: 0; width: 100%;">
                            <li class="w-18">事件名称</li>
                            <li class="w-18">事件时间</li>
                            <li class="w-18">操作人</li>
                            <li class="w-26"></li>
                            <li class="w-26"></li>
                        </ul>
                        <div class="scroll w-100 h-486">
                            <ul class="list-details" v-for="(log,l) in deviceLogList" :key="l">
                                <li class="w-18" :title="log.context">{{log.content}}</li>
                                <li :title="changeTime(log.operateTime)" class="w-18">{{changeTime(log.createdTime)}}</li>
                                <li :title="log.userName" class="w-18">{{log.userName}}<span v-if="log.groupName">/{{log.groupName}}</span></li>
                                <li class="w-26"></li>
                                <li class="w-26"></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="pro-function" v-show="active==2" style="height: 75%">
                    <div></div>
                    <div class="clearfix" style="height: 100%">
                        <ul class="list-title" style="width: 100%; margin: 0;">
                            <li>姓名</li>
                            <li class="w-18">时间</li>
                            <li>维保内容</li>
                            <li class="w-26"></li>
                            <li class="w-26"></li>
                            <li class="w-26"></li>
                        </ul>
                        <div class="scroll w-100 h-486">
                            <ul class="list-details" v-for="(record,r) in repairRecord" :key="r">
                                <li :title="record.userName">{{record.userName}}</li>
                                <li class="w-18">{{changeTime(record.operateTime)}}</li>
                                <li :title="record.context">{{record.context}}</li>
                                <li class="w-26"></li>
                                <li class="w-26"></li>
                                <li class="w-26"></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="page-box" v-show="active == 1 || active == 2">
                    <Pagination @setSize="setSize" @setNum="setNum" :totalCount="totalCount" :setNumber="pageNumber"></Pagination>
                </div>
            </div>
        </div>
        <!-- 弹窗 -->
        <div class="popup">
            <!-- 删除设备 -->
            <div class="popup-delDevice" v-show="delDeviceShow">
                <div class="popup-title">
                    删除设备<i class="el-icon-circle-close close" @click="close('delDeviceShow')"></i>
                </div>
                <div class="popup-lab t-left">
                    系统将删除该设备"{{nowObj.name}}",是否继续？
                    <p class="popup-btn-box"><el-button type="primary" @click="removeDevice">确定</el-button> <el-button @click="close('delDeviceShow')">取消</el-button></p>
                </div>
            </div>
            <!-- 启用设备 -->
            <div class="popup-delDevice" v-show="enableDeviceShow">
                <div class="popup-title">
                    启用设备<i class="el-icon-circle-close close" @click="close('enableDeviceShow')"></i>
                </div>
                <div class="popup-lab t-left">
                    系统将启用该设备"{{nowObj.name}}",是否继续？
                    <p class="popup-btn-box"><el-button type="primary" @click="enableDevice">确定</el-button> <el-button @click="close('enableDeviceShow')">取消</el-button></p>
                </div>
            </div>
            <!-- 停用设备 -->
            <div class="popup-delDevice" v-show="disDeviceShow">
                <div class="popup-title">
                    停用设备<i class="el-icon-circle-close close" @click="close('disDeviceShow')"></i>
                </div>
                <div class="popup-lab t-left">
                    系统将停用该设备"{{nowObj.name}}",是否继续？
                    <p class="popup-btn-box"><el-button type="primary" @click="disDevice">确定</el-button> <el-button @click="close('disDeviceShow')">取消</el-button></p>
                </div>
            </div>
            <!-- 删除扩展属性 -->
            <div class="popup-delDevice" v-show="delAttributeShow">
                <div class="popup-title">
                    删除扩展属性<i class="el-icon-circle-close close" @click="close('delAttributeShow')"></i>
                </div>
                <div class="popup-lab t-left">
                    系统将删除该扩展属性"{{nowObj.name}}",是否继续？
                    <p class="popup-btn-box"><el-button type="primary" @click="delAttribute">确定</el-button> <el-button @click="close('delAttributeShow')">取消</el-button></p>
                </div>
            </div>
            <!-- 添加设备 -->
            <div class="popup-addDevice" v-show="addDeviceShow" style="height:708px;">
                <div class="popup-title">
                    新建设备<i class="el-icon-circle-close close" @click="close('addDeviceShow')"></i>
                </div>
                <p class="addDevice-tips">设备基本信息</p>
                <el-form :model="ruleForm" :rules="rules" ref="addDevice" class="clearfix">
                    <el-form-item label="设备key：" autocomplete="off" class="margin-lab" prop="deviceCode">
                        <el-input v-model="ruleForm.deviceCode" maxlength="32" @input="ruleForm.deviceCode = ruleForm.deviceCode.replace(/^([0-9])/,'').replace(/[^\w]/g,'').replace(/^_/g,'')"></el-input>
                    </el-form-item>
                    <el-form-item label="设备名称：" prop="deviceName" autocomplete="off">
                        <i class="f-l"><img :src="notes" title="须介于1~32个字符之间" class="notes"></i>
                        <el-input v-model="ruleForm.deviceName"></el-input>
                    </el-form-item>
                    <el-form-item label="使用模板：" autocomplete="off" class="no-title" >
                        <!-- <i><img :src="notes" title="" class="notes"></i><br> -->
                        <!-- <el-input v-model="ruleForm.categoryId"></el-input> -->
                        <el-select placeholder="请选择" class="industry" @change="changeMod" v-model="modId" style="width: 100%;">
                            <el-option
                            v-for="item in list"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            v-if="item.name!='虚拟设备'"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="关联产品：" autocomplete="off" prop="productId">
                        <i class="f-l"><img :src="notes" title="以现有产品作为模板自动添加功能和报警" class="notes"></i>
                        <el-cascader :options="productData" :props="optionProps" v-model="ruleForm.productId" class="cascader" @change="attrShow"></el-cascader>
                    </el-form-item>
                    <p class="p-select" v-show="ruleForm.productId.length==4"><span @click="operate('selectAttrShow')">选择属性</span><span @click="warnShow">选择报警</span></p>
                    <p class="p-select disable" v-show="ruleForm.productId.length!=4"><span>选择属性</span><span>选择报警</span></p>
                    <p class="p-select">启用状态: 无</p>
                    <el-form-item label="备注：" autocomplete="off">
                        <i class="f-l"><img :src="notes" title="长度为0~255位字符" class="notes"></i>
                        <el-input
                            type="textarea"
                            class="remarks"
                            v-model="ruleForm.note"
                            maxlength="255"
                            show-word-limit
                            id="editRemarks"
                            placeholder="请输入描述">
                        </el-input>
                    </el-form-item>
                </el-form>
                <p class="btn-box b-32"><el-button type="primary" @click="createDevice('addDevice')">确定</el-button> <el-button @click="close('addDeviceShow')">取消</el-button></p>
            </div>
            <!-- 编辑设备 -->
            <div class="popup-addDevice" v-show="setDeviceShow">
                <div class="popup-title">
                    {{$store.state.functionList.includes('companyServiceDevice')&&!$store.state.isLook?'编辑':'查看'}}设备<i class="el-icon-circle-close close" @click="close('setDeviceShow')"></i>
                </div>
                <p class="addDevice-tips">设备基本信息</p>
                <el-form :model="ruleForm" :rules="rules" ref="setDevice" class="clearfix" :disabled="!$store.state.functionList.includes('companyServiceDevice')||$store.state.isLook">
                    <el-form-item label="设备key：" autocomplete="off" class="margin-lab" prop="deviceCode">
                        <el-input v-model="ruleForm.code" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="设备名称：" prop="deviceName" autocomplete="off">
                        <i class="f-l"><img :src="notes" title="须介于1~32个字符之间" class="notes"></i>
                        <el-input v-model="ruleForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="关联产品：" autocomplete="off" prop="productId">
                        <i class="f-l"><img :src="notes" title="以现有产品作为模板自动添加功能和报警" class="notes"></i>
                        <el-cascader disabled :options="productData" :props="optionProps" v-model="ruleForm.productId" class="cascader" @change="attrShow"></el-cascader>
                    </el-form-item>
                    <p class="p-select" v-show="ruleForm.productId"><span @click="operate('selectAttrShow')">选择属性</span><span @click="warnShow">选择报警</span></p>
                    <p class="p-select">启用状态:{{deviceState(ruleForm.state)}}</p>
                    <el-form-item label="备注：" autocomplete="off">
                        <i class="f-l"><img :src="notes" title="长度为0~255位字符" class="notes"></i>
                        <el-input
                            type="textarea"
                            class="remarks"
                            v-model="ruleForm.note"
                            maxlength="255"
                            show-word-limit
                            id="editRemarks2"
                            placeholder="请输入描述">
                        </el-input>
                    </el-form-item>
                </el-form>
                <p class="btn-box b-32"><el-button type="primary" :disabled="!$store.state.functionList.includes('companyServiceDevice')||$store.state.isLook" @click="editDevice('setDevice')">确定</el-button> <el-button @click="close('setDeviceShow')">取消</el-button></p>
            </div>
            <!-- 添加设备扩展属性 -->
            <div class="popup-addExtend" v-show="addExtendShow">
                <div class="popup-title">
                    新建扩展属性<i class="el-icon-circle-close close" @click="close('addExtendShow')"></i>
                </div>
                <el-form :model="ruleForm" :rules="rules" ref="addInvAttr" class="clearfix">
                    <el-form-item label="属性名称：" autocomplete="off" class="margin-lab" prop="attributeName">
                        <el-input v-model="ruleForm.attributeName"></el-input>
                    </el-form-item>
                    <el-form-item label="标识符：" autocomplete="off" class="margin-lab" prop="code">
                        <el-input v-model="ruleForm.code" maxlength="32" @input="ruleForm.code = ruleForm.code.replace(/^([0-9])/,'').replace(/[^\w]/g,'').replace(/^_/g,'')"></el-input>
                    </el-form-item>
                    <el-form-item label="函数：" prop="function" autocomplete="off" class="w-100 margin-lab">
                        <el-select v-model="ruleForm.function" placeholder="请选择" class="function" @change="changeFunc">
                            <el-option value='add' label="求和"></el-option>
                            <el-option value='sub' label="求差"></el-option>
                            <el-option value='max' label="最大"></el-option>
                            <el-option value='min' label="最小"></el-option>
                            <el-option value='avg' label="平均"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item autocomplete="off" class="w-100 m-b-0" prop="invAttr">
                        <div class="invAttr-scorll-box">
                            <div v-for="invAttr,i in ruleForm.inventedAttrArr" class="invAttr-box" :key='i'>
                                <p class="invAttr-title"><i class="star">*</i>属性{{i+1}}</p>
                                <el-form-item label="" autocomplete="off" class="w-28" :prop="`inventedAttrArr.${i}.deviceCode`" :rules="rules.invAttr_deviceCode">
                                    <el-select v-model="invAttr.deviceCode" placeholder="请选择" class="attribute" @change="getinvAttr($event,i)">
                                        <el-option
                                            v-for="item in dataList"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.code">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="" autocomplete="off" class="w-28" :prop="`inventedAttrArr.${i}.property`" :rules="rules.invAttr_property">
                                    <el-select v-model="invAttr.property" placeholder="请选择" class="attribute">
                                        <el-option
                                            v-for="inv,index in invAttr.invAttrArr"
                                            :value='inv.identifier'
                                            :key="inv.index"
                                            :label="inv.name"
                                            v-if="inv.dataType.type == 'int'||inv.dataType.type == 'double'||inv.dataType.type == 'float'">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <span class="del disabled2" v-show="ruleForm.inventedAttrArr.length < 3">删除</span>
                                <span class="add-p" v-show="ruleForm.inventedAttrArr.length >=3" @click="delInvAttrLab(i)">删除</span>
                            </div>
                        </div>
                        <p class="add-p" v-show="ruleForm.function != 'sub'" @click="addInvAttrLab">+添加属性</p>
                        <p class="add-p disabled2" v-show="ruleForm.function == 'sub'">+添加属性</p>
                    </el-form-item>
                    <el-form-item prop="define" label="数值定义：" autocomplete="off" class="m-b-10 w-100 m-t-15">
                        <div class="define">
                            下下限<span class="border-red"><el-input v-model="ruleForm.errorDown" @input="inputChange('errorDown')"></el-input></span>
                            下限<span class="border-yellow"><el-input v-model="ruleForm.warnDown" @input="inputChange('warnDown')"></el-input></span>
                            上限<span class="border-yellow"><el-input v-model="ruleForm.warnUp" @input="inputChange('warnUp')"></el-input></span>
                            上上限<span class="border-red m-r-0"><el-input v-model="ruleForm.errorUp" @input="inputChange('errorUp')"></el-input></span>
                        </div>
                    </el-form-item>
                    <el-form-item prop="step" label="步长：" autocomplete="off" class="m-b-10 f-l" style="width: 47% !important;">
                        <el-input v-model="ruleForm.step" placeholder="请输入步长" @input="inputChange('step')"></el-input>
                    </el-form-item>
                    <el-form-item label="单位：" autocomplete="off" class="m-b-10 f-r" style="width: 47% !important;">
                        <div class="func-select">
                            <el-select v-model="ruleForm.unit" filterable  placeholder="请选择">
                                <el-option
                                  v-for="item in unitData"
                                  :key="item.Symbol"
                                  :label="`${item.Name+'/'+item.Symbol}`"
                                  :value="item.Symbol">
                                </el-option>
                            </el-select>
                        </div>
                    </el-form-item>
                    <el-form-item label="备注：" autocomplete="off" style="padding-top: 65px;">
                        <el-input
                            type="textarea"
                            class="remarks"
                            v-model="ruleForm.note"
                            maxlength="255"
                            show-word-limit
                            id="editRemarks3"
                            placeholder="请输入描述">
                        </el-input>
                    </el-form-item>
                </el-form>
                <p class="btn-box b-32"><el-button type="primary" @click="addInvAttr">确定</el-button> <el-button @click="close('addExtendShow')">取消</el-button></p>
            </div>
            <!-- 编辑设备扩展属性 -->
            <div class="popup-addExtend" v-show="editExtendShow">
                <div class="popup-title">
                    {{$store.state.functionList.includes('companyServiceDevice')&&!$store.state.isLook?'编辑':'查看'}}扩展属性<i class="el-icon-circle-close close" @click="close('editExtendShow')"></i>
                </div>
                <el-form :model="ruleForm" :rules="rules" ref="editInvAttr" class="clearfix" :disabled="!$store.state.functionList.includes('companyServiceDevice')||$store.state.isLook">
                    <el-form-item label="属性名称：" autocomplete="off" class="margin-lab" prop="attributeName">
                        <el-input v-model="ruleForm.attributeName"></el-input>
                    </el-form-item>
                    <el-form-item label="标识符：" autocomplete="off" class="margin-lab" prop="code">
                        <el-input v-model="ruleForm.code" maxlength="32" @input="ruleForm.code = ruleForm.code.replace(/^([0-9])/,'').replace(/[^\w]/g,'').replace(/^_/g,'')"></el-input>
                    </el-form-item>
                    <el-form-item label="函数：" prop="function" autocomplete="off" class="w-100 margin-lab">
                        <el-select v-model="ruleForm.function" placeholder="请选择" class="function" @change="changeFunc">
                            <el-option value='add' label="求和"></el-option>
                            <el-option value='sub' label="求差"></el-option>
                            <el-option value='max' label="最大"></el-option>
                            <el-option value='min' label="最小"></el-option>
                            <el-option value='avg' label="平均"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item autocomplete="off" class="w-100 m-b-0" prop="invAttr">
                        <div class="invAttr-scorll-box">
                            <div v-for="invAttr,i in ruleForm.inventedAttrArr" class="invAttr-box" :key='i'>
                                <p class="invAttr-title"><i class="star">*</i>属性{{i+1}}</p>
                                <el-form-item label="" autocomplete="off" class="w-28" :prop="`inventedAttrArr.${i}.deviceCode`" :rules="rules.invAttr_deviceCode">
                                    <el-select v-model="invAttr.deviceCode" placeholder="请选择" class="attribute" @change="getinvAttr($event,i)">
                                        <el-option
                                            v-for="item in dataList"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.code">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="" autocomplete="off" class="w-28" :prop="`inventedAttrArr.${i}.property`" :rules="rules.invAttr_property">
                                    <el-select v-model="invAttr.property" placeholder="请选择" class="attribute">
                                        <el-option
                                            v-for="inv,index in invAttr.invAttrArr"
                                            :value='inv.identifier'
                                            :key="inv.index"
                                            :label="inv.name"
                                            v-if="inv.dataType.type == 'int'||inv.dataType.type == 'double'||inv.dataType.type == 'float'">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <span class="del disabled2" v-show="ruleForm.inventedAttrArr.length < 3">删除</span>
                                <span class="add-p" v-show="ruleForm.inventedAttrArr.length >=3" @click="delInvAttrLab(i)">删除</span>
                            </div>
                        </div>
                        <p class="add-p" v-show="ruleForm.function != 'sub'&&$store.state.functionList.includes('companyServiceDevice')&&!$store.state.isLook" @click="addInvAttrLab">+添加属性</p>
                        <p class="add-p disabled2" v-show="ruleForm.function == 'sub'||!$store.state.functionList.includes('companyServiceDevice')||$store.state.isLook">+添加属性</p>
                    </el-form-item>
                    <el-form-item prop="define" label="数值定义：" autocomplete="off" class="m-b-10 w-100 m-t-15">
                        <div class="define">
                            下下限<span class="border-red"><el-input v-model="ruleForm.errorDown" @input="inputChange('errorDown')"></el-input></span>
                            下限<span class="border-yellow"><el-input v-model="ruleForm.warnDown" @input="inputChange('warnDown')"></el-input></span>
                            上限<span class="border-yellow"><el-input v-model="ruleForm.warnUp" @input="inputChange('warnUp')"></el-input></span>
                            上上限<span class="border-red m-r-0"><el-input v-model="ruleForm.errorUp" @input="inputChange('errorUp')"></el-input></span>
                        </div>
                    </el-form-item>
                    <el-form-item prop="step" label="步长：" autocomplete="off" class="m-b-10 f-l" style="width: 47% !important;">
                      <el-input v-model="ruleForm.step" placeholder="请输入步长" @input="inputChange('step')"></el-input>
                    </el-form-item>
                    <el-form-item label="单位：" autocomplete="off" class="m-b-10 f-r" style="width: 47% !important;">
                        <div class="func-select">
                            <el-select v-model="ruleForm.unit" filterable  placeholder="请选择">
                                <el-option
                                  v-for="item in unitData"
                                  :key="item.Symbol"
                                  :label="`${item.Name+'/'+item.Symbol}`"
                                  :value="item.Symbol">
                                </el-option>
                            </el-select>
                        </div>
                    </el-form-item>
                    <el-form-item label="备注：" autocomplete="off" style="padding-top: 65px;">
                        <el-input
                            type="textarea"
                            class="remarks"
                            v-model="ruleForm.note"
                            maxlength="255"
                            show-word-limit
                            id="editRemarks4"
                            placeholder="请输入描述">
                        </el-input>
                    </el-form-item>
                </el-form>
                <p class="btn-box b-32"><el-button type="primary" @click="editInvAttr" :disabled="!$store.state.functionList.includes('companyServiceDevice')||$store.state.isLook">确定</el-button> <el-button @click="close('editExtendShow')">取消</el-button></p>
            </div>
            <!-- 选择属性 -->
            <div class="popup-select-attribute" v-show="selectAttrShow">
                <div class="popup-title no-border">
                    选择属性<i class="el-icon-circle-close close" @click="cancal('selectAttrShow')"></i>
                </div>
                <div class="option-box">
                    <template>
                        <p class="option-box-top">属性名称<el-checkbox class="all-check" :indeterminate="isIndeterminate" v-model="checkAll" @change="attrAllChange">全选</el-checkbox></p>
                        <div class="option-scorll-box">
                            <el-checkbox-group v-model="ruleForm.attr" @change="attrCheckedChange">
                                <el-checkbox v-for="attr in attrData" :label="attr.identifier" :key="attr.identifier">{{attr.name}}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </template>
                </div>
                <p class="btn-box b-32"><el-button type="primary" @click="close('selectAttrShow')">确定</el-button> <el-button @click="cancal('selectAttrShow')">取消</el-button></p>
            </div>
            <!-- 选择报警 -->
            <div class="popup-select-attribute" v-show="selectWarnShow">
                <div class="popup-title no-border">
                    选择报警<i class="el-icon-circle-close close" @click="cancal('selectWarnShow')"></i>
                </div>
                <div class="option-box">
                    <template>
                        <p class="option-box-top">报警名称<el-checkbox class="all-check" :indeterminate="isIndeterminateWarn" v-model="checkAllWarn" @change="warnAllChange">全选</el-checkbox></p>
                        <div class="option-scorll-box">
                            <el-checkbox-group v-model="ruleForm.warn" @change="warnCheckedChange">
                                <el-checkbox v-for="warn in warnData" :label="warn.id" :key="warn.id">{{warn.name}}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </template>
                </div>
                <p class="btn-box b-32"><el-button type="primary" @click="close('selectWarnShow')">确定</el-button> <el-button @click="cancal('selectWarnShow')">取消</el-button></p>
            </div>
            <!-- 实时数据 -->
            <div class="popup-nowData" v-show="nowDataShow">
                <div class="popup-title no-border">
                    {{nowObj.name}}<i class="el-icon-circle-close close" @click="close('nowDataShow')"></i>
                </div>
                <div class="data-box">
                    <div class="data-lab" v-for="(devAttr,d) in devData" :key="d">
                        <div v-if="devAttr.accessMode == 'rw'"><p class="attr-name" :title="devAttr.name">{{devAttr.name}}</p>&nbsp;:
                            <span class="f-r bool" v-if="devAttr.type == 'bool'">
                                <span class="data-span">{{devAttr.specs[devAttr.value]}}</span>
                                <span :ref="addref('bool',d)" class="f-r" v-show="$store.state.functionList.includes('companyServiceDevice')&&!$store.state.isLook&&$store.state.functionList.includes('companyServiceContrl')">
                                    <span v-for="(boolObj,b) in devAttr.selectData" :key="b">
                                        <el-button v-show="devAttr.value != boolObj.key&&devAttr.value!=null" class="active-btn data-btn" @click="changeBool(devAttr,boolObj.key,d)" :title="boolObj.value">{{boolObj.value}}</el-button>
                                    </span>
                                </span>
                                <el-button class="active-btn data-btn loading-btn" :loading="true" :ref="addref('boolLoad',d)"></el-button>
                            </span>
                            <span class="f-r" v-if="devAttr.type == 'enum'">
                                <span :ref="addref('enumLoadHide',d)">{{devAttr.specs[devAttr.value]}}</span>
                                <el-select v-model="valueArr[d]" placeholder="请选择" class="enum" @change='changeEnum($event,devAttr,d)' :disabled="!$store.state.functionList.includes('companyServiceDevice')||$store.state.isLook||!$store.state.functionList.includes('companyServiceContrl')">
                                    <el-option
                                        v-for="enumObj,e in devAttr.selectData"
                                        :key="enumObj.e"
                                        :label="enumObj.value"
                                        :value="enumObj.key">
                                    </el-option>
                                </el-select>
                            </span>

                            <span class="f-r bool" v-if="devAttr.type == 'int'||devAttr.type == 'float'||devAttr.type == 'double'">
                                <span class="data-span f-l" :style="{'color':devAttr.color}">{{devAttr.value==null?'':common.fmoney(devAttr.value,devAttr.dataType.specs.step)}}&nbsp;{{devAttr.specs.unit}}</span><span :ref="addref('editVal',d)" v-show="$store.state.functionList.includes('companyServiceDevice')&&!$store.state.isLook&&$store.state.functionList.includes('companyServiceContrl')" class="data-btn m-r-5 active-btn" @click="editAttr(devAttr,d)">设定</span>
                                <el-button class="active-btn f-r data-btn loading-btn" :loading="true" :ref="addref('editValLoad',d)"></el-button>
                            </span>
                            <span class="f-r bool" v-if="devAttr.type == 'text'">
                                <span class="data-span f-l" :ref="addref('editTextVal',d)" :style="{'color':devAttr.color}">{{devAttr.value==null?'':devAttr.value}}</span><span :ref="addref('editVal',d)"  v-show="$store.state.functionList.includes('companyServiceDevice')&&!$store.state.isLook&&$store.state.functionList.includes('companyServiceContrl')" class="data-btn m-r-5 active-btn" @click="editAttr(devAttr,d)">设定</span>
                                <el-button class="active-btn f-r data-btn loading-btn" :loading="true" :ref="addref('editValLoad',d)"></el-button>
                            </span>
                            <span class="f-r bool" v-if="devAttr.type == 'date'">
                                <span class="data-span f-l" :ref="addref('editTextVal',d)" :style="{'color':devAttr.color}">{{devAttr.value==null?'':changeTime(devAttr.value)}}&nbsp;</span><span :ref="addref('editVal',d)"  v-show="$store.state.functionList.includes('companyServiceDevice')&&!$store.state.isLook&&$store.state.functionList.includes('companyServiceContrl')" class="data-btn m-r-5 active-btn" @click="editAttr(devAttr,d)">设定</span >
                                <el-button class="active-btn f-r data-btn loading-btn" :loading="true" :ref="addref('editValLoad',d)"></el-button>
                            </span>
                        </div>
                        <div v-if="devAttr.accessMode == 'r'&&devAttr.type!='bool'&&devAttr.type!='enum'&&devAttr.type!='text'&&devAttr.type!='date'">
                            <p class="attr-name" :title="devAttr.name">{{devAttr.name}}</p>&nbsp;:
                            <span class="f-r"><span class="f-r m-r-5" :style="{'color':devAttr.color}">{{devAttr.value==null?'':common.fmoney(devAttr.value,devAttr.dataType.specs.step)}}&nbsp;{{devAttr.specs.unit}}</span></span>
                        </div>
                        <div v-if="devAttr.accessMode == 'r'&&(devAttr.type=='bool'||devAttr.type=='enum')">
                            <p class="attr-name" :title="devAttr.name">{{devAttr.name}}</p>&nbsp;:
                            <span class="f-r"><span class="f-r m-r-5" :style="{'color':devAttr.color}">{{devAttr.specs[devAttr.value]}}</span></span>
                        </div>
                        <div v-if="devAttr.accessMode == 'r'&&devAttr.type=='text'">
                            <p class="attr-name" :title="devAttr.name">{{devAttr.name}}</p>&nbsp;:
                            <span class="f-r"><span class="f-r m-r-5" :style="{'color':devAttr.color}">{{devAttr.value}}</span></span>
                        </div>
                        <div v-if="devAttr.accessMode == 'r'&&devAttr.type=='date'">
                            <p class="attr-name" :title="devAttr.name">{{devAttr.name}}</p>&nbsp;:
                            <span class="f-r"><span class="f-r m-r-5" :style="{'color':devAttr.color}">{{changeTime(devAttr.value)}}</span></span>
                        </div>
                    </div>
                </div>
                <p class="btn-box b-32"><el-button type="primary" @click="close('nowDataShow')">关闭</el-button></p>
            </div>
            <div class="popup-nowData" v-show="nowDataVirtualDeviceShow">
                <div class="popup-title no-border">
                    虚拟设备<i class="el-icon-circle-close close" @click="close('nowDataVirtualDeviceShow')"></i>
                </div>
                <div class="data-box">
                    <div class="data-lab" v-for="(devAttr,d) in VirtualFuncList" :key="d">
                        <div >
                            <p class="attr-name">{{devAttr.name}}</p>&nbsp;:
                            <span class="f-r"><span class="f-r m-r-5" :style="{'color':devAttr.color}">{{devAttr.value==null?'':common.fmoney(devAttr.value,devAttr.step)}} {{devAttr.unit}}</span></span>
                        </div>
                    </div>
                </div>
                <p class="btn-box b-32"><el-button type="primary" @click="close('nowDataVirtualDeviceShow')">关闭</el-button></p>
            </div>
            <!-- 验证码授权 -->
            <div class="popup-clear" v-show='functionShow' id="privilege" style="height: 349px;text-align: left;margin-left: -216px; z-index:1000 !important;">
                <div class="popup-title">
                    获取验证码授权<i><img :src="notes" title="提示" class="notes"></i><i class="el-icon-circle-close close" @click="close('functionShow')" id="closeClear3"></i>
                </div>
                <div class="popup-lab">
                    手机号：
                    <el-input disabled v-model="phone">{{phone}}</el-input>
                </div>
                <div class="popup-lab clearfix">
                    <p style="position: relative; left: -11px;"><i class="star">*</i>验证码：</p>
                    <el-form style="float: left; width: 255px;" :model="verifyForm" :rules="rules" ref="verifyCode" @submit.native.prevent>
                        <el-form-item prop="verifyCode">
                            <el-input id="verifyCode2" class="verifyCode" placeholder="请输入4位验证码" v-model='verifyForm.verifyCode' maxlength="4" @input="verifyForm.verifyCode=verifyForm.verifyCode.replace(/[^\d]/g, '')"></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="code-box">
                        <p class="get-code" v-show="getCodeShow" @click.stop='getCode' id="getCodeBtn2">获取验证码</p>
                        <p class="countdown" v-show="countdownShow">{{second}}S后重新获取</p>
                    </div>
                </div>
                <div class="popup-lab">
                    <p class="btn-box" style="margin-top: 26px;">
                        <el-button type="primary" @click="Privilege" id="toClear2">确定</el-button>
                        <el-button @click="close('functionShow')" id="closeClear4">取消</el-button>
                    </p>
                </div>
            </div>
        </div>
        <div class="popup-editAttr" v-show='functionShow'></div>
        <!-- 修改属性 -->
        <div class="popup-editAttr" v-show='editAttrShow'>
            <div class="popup-content">
                <div class="content-top">
                    {{nowEditAttr.name}}
                </div>
                <i><img class="close" :src="closeImg" @click="close('editAttrShow')"></i>
                <div class="input-box">
                    <el-form :model="editAttrForm" :rules="rules" ref="editAttrRef" @submit.native.prevent>
                        <el-form-item prop="editAttrVal" v-if="editAttrForm.type!='date'&&editAttrForm.type!='text'">
                            <el-input class="" v-model="editAttrForm.editAttrVal" @input="editAttrForm.editAttrVal = editAttrForm.editAttrVal.replace(/[^\-?\d.]/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^\./g,'').replace(/--/g, '-')"></el-input>
                        </el-form-item>
                        <el-form-item prop="editAttrVal" v-if="editAttrForm.type=='date'">
                            <el-date-picker
                            class="dataTime"
                            v-model="editAttrForm.editAttrVal"
                            type="datetime"
                            value-format='timestamp'
                            placeholder="选择日期时间">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item prop="editAttrVal" v-if="editAttrForm.type=='text'">
                            <el-input class="" v-model="editAttrForm.editAttrVal"></el-input>
                        </el-form-item>
                    </el-form>
                    <span class="unit" v-if="nowEditAttr.specs">{{nowEditAttr.specs.unit}}</span>
                </div>
                <p class="btn-box b-32"><el-button type="primary" :disabled="!$store.state.functionList.includes('companyServiceDevice')||$store.state.isLook" @click="updateAttr">确定</el-button> <el-button @click="close('editAttrShow')">取消</el-button></p>
            </div>
        </div>
        <!-- 排序弹窗 -->
        <div class="popup">
          <div class="popup-paixu" v-show="paixuShow">
                <div class="popup-title">
                    设备排序<i class="el-icon-circle-close close" @click="close('paixuShow')"></i>
                </div>
                <div class="poput-lab h-500">
                  <sortable v-for="(device,d) in pxList" :key="d" :index="d" :options = "{animation:150}" v-model="dragData" class="sort-list" @sortend="sortend($event, pxList)" @mouseover.native="showBtnIndex=d">
                      <sapn>{{device.name}}</sapn>
                      <span class="icon-box" v-show="showBtnIndex==d">
                        <img :src="di" @click="rearrange(pxList, d, pxList.length-1)">
                        <img :src="ding" @click="rearrange(pxList, d, 0)">
                      </span>
                  </sortable>
                </div>
                <p class="btn-box b-32"><el-button type="primary" @click="sortArr">确定</el-button> <el-button @click="close('paixuShow')">取消</el-button></p>
          </div>
        </div>
        <div class="popup">
          <div class="popup-editGroup" v-show="editGroupShow">
                <div class="popup-title">
                    修改分组<i class="el-icon-circle-close close" @click="close('editGroupShow')"></i>
                </div>
                <!-- :model='ruleForm' :rules="rules" ref="addForm"  -->
                <el-form class="clearfix">
                  <div class="popup-lab m-t-15">
                    <el-form-item label="所属组织：" autocomplete="off" class="no-title">
                      <el-cascader class="w-466"
                          v-model="groupId"
                          :options="$store.state.deviceTreeData"
                          :props="optionProps2"
                          :show-all-levels="false"
                          ></el-cascader>
                    </el-form-item>
                  </div>
                </el-form>
                <p class="btn-box b-32"><el-button type="primary" @click="editGroup">确定</el-button> <el-button @click="close('editGroupShow')">取消</el-button></p>
          </div>
        </div>
        
      <div class="device-media-preview" v-show="extMediaPreviewShow">
        <div class="device-media-preview-title">{{ extCurrentMedia.name || '媒体预览' }}<i class="el-icon-circle-close" @click="closeExtMediaPreview"></i></div>
        <div class="device-media-preview-content">
          <img v-if="isExtImage(extCurrentMedia)" :src="buildExtMediaUrl(extCurrentMedia.url)" class="device-media-preview-image">
          <video v-else-if="isExtVideo(extCurrentMedia)" :src="buildExtMediaUrl(extCurrentMedia.url)" class="device-media-preview-video" controls autoplay playsinline preload="metadata"></video>
          <div v-else class="device-media-preview-unsupported"><i class="el-icon-document"></i><span>当前文件类型暂不支持预览</span></div>
        </div>
        <div class="device-media-preview-footer"><el-button @click="closeExtMediaPreview">关闭</el-button></div>
      </div>
    </div>
</template>
<script>
import Pagination from "@/components/PublicAssembly/pagination"
import Sortable from 'vue-drag-sortable'
import unit from "@/assets/js/unit.json"
import tree from "@/components/PublicAssembly/deviceTree"
export default {
    components: {
      Sortable,
      Pagination,
      tree
    },
    data() {
        var valiName = (rule, value, callback) =>{      //设备名称
            // let reg=/^[A-Za-z0-9-_\u4e00-\u9fa5]{1,32}$/;
            if(this.setDeviceShow){
                value = this.ruleForm.name
            }
            if(value == "" ||value==null){
                callback(new Error('请输入设备名称'));
            }else if(value.length>32){
                callback(new Error('设备名称由1~32个字符构成'));
            }else{
                callback();
            }
        }
        var valiattrName = (rule, value, callback) =>{      //扩展属性名称
            // let reg=/^[A-Za-z0-9-_\u4e00-\u9fa5]{1,32}$/;
            if(value == "" ||value==null){
                callback(new Error('请输入扩展属性名称'));
            }else if(value.length>32){
                callback(new Error('扩展属性名称由1~32个字符构成'));
            }else if(this.VirtualFuncList.filter(i=>i.name == value)[0]&&this.addExtendShow){
                callback(new Error('扩展属性名称已存在'));
            }else{
                callback();
            }
        }
        var valiProduct = (rule, value, callback) =>{      //关联产品
            if(this.setDeviceShow){
                callback()
            }
            if(this.ruleForm.productId.length !=4){
                callback(new Error('请选择关联产品'));
            }else{
                callback()
            }
        }
        var define = (rule, value, callback) =>{        //数据定义
            let warnUp = this.ruleForm.warnUp;     //上限
            let warnDown = this.ruleForm.warnDown;      //下限
            let errorUp = this.ruleForm.errorUp;//上上限
            let errorDown = this.ruleForm.errorDown;//下下限
            let max = this.ruleForm.max,min=this.ruleForm.min
            if(warnDown!="" && warnDown !=null && errorDown!="" && errorDown !=null && Number(errorDown)>Number(warnDown)){
                callback(new Error('下下限需小于或等于下限'));
            }else if(warnDown!="" && warnDown !=null && warnUp!="" && warnUp !=null && Number(warnDown)>Number(warnUp)){
                callback(new Error('下限需小于或等于上限'));
            }else if(warnUp!="" && warnUp !=null && errorUp!="" && errorUp !=null && Number(warnUp)>Number(errorUp)){
                callback(new Error('上限需小于或等于上上限'));
            }else if(errorUp!="" && errorUp !=null && errorDown!="" && errorDown !=null && Number(errorDown)>Number(errorUp)){
                callback(new Error('下下限需小于或等于上上限'));
            }else if(warnUp!="" && warnUp !=null && errorDown!="" && errorDown !=null && Number(errorDown)>Number(warnUp)){
                callback(new Error('下下限需小于或等于上限'));
            }else if(errorUp!="" && errorUp !=null && warnDown!="" && warnDown !=null && Number(warnDown)>Number(errorUp)){
                callback(new Error('下限需小于或等于上上限'));
            }else {
                callback();
            }
        }
        var invAttr =  (rule, value, callback) =>{      //属性定义
            callback()
        }
        var invproperty =  (rule, value, callback) =>{      //属性定义
            if(value == ''||value==null){
                callback(new Error('请选择属性'))
            }else{
                callback()
            }
        }
        var invdeviceCode =  (rule, value, callback) =>{      //属性定义
            if(value == ''||value==null){
                callback(new Error('请选择设备'))
            }else{
                callback()
            }
        }
        var invEditAttr=(rule, value, callback) =>{      //属性定义
            if(!value){
                callback(new Error(`值不能为空`))
            }else{
                let val = Number(value)
                // console.log(this.editAttrForm.type)
                if(this.editAttrForm.type =='date'||this.editAttrForm.type=='text'){
                    callback()
                }else if(Number(this.nowEditAttr.specs.max)<val||Number(this.nowEditAttr.specs.min)>val){
                    callback(new Error(`输入值超出范围，范围：${this.nowEditAttr.specs.min}~${this.nowEditAttr.specs.max}`));
                }else {
                    callback();
                }
           }
        }
        var step = (rule, value, callback) =>{          //步长
            let reg = /^(\d+)(\.\d+)?$/;
            value=Number(value)
            if(!reg.test(value)){
                callback(new Error('步长格式错误，请输入正数'));
            }else{
                callback();
            }
            // else if((max-min)%value!=0){
            //     callback(new Error('步长'));
            // }
        }
        return {
            extMediaPreviewShow: false,
            extCurrentMedia: {},
            notes:require('@/assets/image/organize/notes.png'),
            right:require('@/assets/image/index/right.png'),
            closeImg:require('@/assets/image/index/close.png'),
            closeActiveImg:require('@/assets/image/index/close2.png'),
            back:null,
            modId:null,
            dataList:[],            //设备列表
            list:[],                //展示列表
            showCodeArr:[],
            VirtualFuncList:[],     //虚拟设备属性列表
            deviceLogList:[],       //设备日志
            repairRecord:[],        //设备维保记录
            VirtualDevice:{},       //虚拟设备
            beginDate:"",           //开始时间
            endDate:"",             //结束时间
            searchVal:"",           //搜索值
            totalCount:0,
            pageSize:0,
            checkObj:[],
            searchAttrVal:'',
            showCheck:false,
            pageNumber:1,
            delDeviceShow:false,    //删除设备
            enableDeviceShow:false, //启用设备
            disDeviceShow:false,    //禁用设备
            delAttributeShow:false, //删除扩展属性
            addDeviceShow:false,    //添加设备
            breadcrumbShow:false,   //头部面包屑
            isFictitious:false,     //虚拟设备页面
            setDeviceShow:false,    //编辑设备
            nowDataVirtualDeviceShow:false, //虚拟设备实时数据
            isList:true,            //列表
            isEditExtend:false,     //判断是否编辑扩展属性
            editDeviceShow:false,   //修改设备
            addExtendShow:false,    //添加设备扩展属性
            editExtendShow:false,   //修改设备扩展属性
            selectAttrShow:false,   //选择属性
            selectWarnShow:false,   //选择报警
            editAttrShow:false,     //修改属性值弹窗
            editGroupShow:false,     //修改分组弹窗
            oldArr:[],              //旧数组，保存旧的属性
            oldWarn:[],             //旧数组，保存旧的报警
            nowDataShow:false,      //实时数据
            active:0,
            nowObj:{},
            nowEditAttr:{},         //当前修改的属性对象
            nowEditAttrIndex:null,  //当前修改值下标
            nowIndex:null,
            ruleForm:{  //表单验证
                deviceCode:"",  //设备id
                deviceName:"",  //设备名称
                product:null,
                code:'',
                note:"",        //备注
                productId:[],   //关联产品id
                attributeName:'',   //属性名称
                function:"add",     //函数
                warnUp:null,      //上限
                warnDown:null,    //下限
                errorUp:null,     //上上限
                errorDown:null,   //下下限
                warn:[],        //选择报警
                attr:[],        //选择属性
                unit:null,          //单位
                asd:null,
                step:null,      //步长
                inventedAttrArr:[
                    {deviceCode:null,property:null,invAttrArr:[]},
                    {deviceCode:null,property:null,invAttrArr:[]},
                ],
            },
            verifyForm:{
                verifyCode:'',
            },
            editAttrForm:{
                editAttrVal:'',
                type:'',
            },
            rules:{     //验证规则
                deviceName:[{validator: valiName, required: true, trigger: 'blur'}],
                productId:[{type:'array',validator:valiProduct, required: true, trigger: 'change'}],
                attributeName:[{validator: valiattrName, required: true, trigger: 'blur'}],
                function:[{required: true, trigger: 'blur'}],
                define:[{validator: define, required: false, trigger: 'blur'}],
                invAttr:[{ validator: invAttr,required: true}],
                code:[{required: true, message:'标识符不能为空', trigger: 'blur'}],
                verifyCode:[{ message: '请输入验证码', required: true, trigger: 'blur' }],
                deviceCode:[{ required: true, message:'设备key不能为空', trigger: 'blur'}],
                editAttrVal:[{validator: invEditAttr, required: false, trigger: 'blur'}],
                invAttr_deviceCode:[{validator: invdeviceCode, required: true, trigger: 'change'}],
                invAttr_property:[{ validator: invproperty, required: true, trigger: 'change'}],
                step:[{validator: step, trigger: 'blur'}],
            },
            categoryData:null,  //产品类别数据
            productData:[],     //产品数据
            allProductData:[],  //所有产品数据
            optionProps: {
                value: 'id',
                label: 'name',
                children: 'children',
                expandTrigger: 'hover',
                code:"",
            },
            optionProps2: {
                value: 'id',
                label: 'name',
                children: 'children',
                expandTrigger: 'hover',
                checkStrictly: true,
                emitPath:false
            },
            isIndeterminate: false,
            isIndeterminateWarn: false,
            checkAll: false,
            checkAllWarn:false,
            attrData:[],        //属性数据
            warnData:[],        //报警数据
            allWarn:[1,2,3,4,5,6,7,8,9],
            allAttr:[1,2,3,4,5,6,7,8,9],
            devData:[], //设备属性
            valueArr:[], //存放设备属性值
            unitData:[],    //单位数据
            client:false,
            getClient:null,
            functionShow:false,
            VerifyArr:[],
            second:60,
            getCodeShow:true,
            countdownShow:false,
            phone:'',
            time:null,
            pickerOptionsStart: {
                disabledDate: time => {
                    if (this.endTime) {
                        return time.getTime() > new Date(this.endTime).getTime()
                    }
                }
            },
            pickerOptionsEnd: {
                disabledDate: time => {
                    if (this.beginDate) {
                        return time.getTime() < new Date(this.beginDate).getTime() - 86400000
                    }
                }
            },
            configArr:[],   //用户配置的排序数组
            paixuShow:false,  //排序
            pxList:[],
            di:require('@/assets/image/paixu/di.png'),
            ding:require('@/assets/image/paixu/ding.png'),
            dragData:{},
            showBtnIndex:null,
            treeId:0,
            groupId:'0'
        }
    },
    props: {
        companyId:{
            type:Number,
            required:true,
        },
    },
    computed:{
      treeType(){
        return this.$store.state.deviceTreeType
      },
    },
    created() {
        this.unitData = unit;
        this.back = require('@/assets/image/index/back'+this.cssType+'.png')
        this.$store.state.headerActive=1;
        this.pageSize=this.$store.state.userConfig.rowsPerPage;
        this.phone=this.hidePhone(this.$store.state.userData.mobile);
        this.getProduct();
        this.getList(1);
        this.$store.state.mask=false
    },
    mounted() {
        this.getClient=setInterval(()=>{        //获取mqtt对象
            if(this.$store.state.client){
                this.client = this.$store.state.client
                clearInterval(this.getClient)
                this.getClient=undefined
                // console.log(this.client)
            }else{
                let options = {
                    clientId:this.$store.state.userData.code+'_'+this.$store.state.companyCode+'_device',
                    connectTimeout: 600000,
                    clean: true
                }
                this.$store.state.client = this.$mqtt.connect(this.$store.state.MQTT_SERVICE, options)
                this.client = this.$store.state.client
            }
        },1000)
    },
    methods: {
        getExtMediaList(fileUrl) {
            return String(fileUrl || '').split(',').map(url => url.trim()).filter(Boolean).map((url, index) => {
                const rawName = url.split('/').pop().split('?')[0] || ('媒体文件' + (index + 1))
                let name = rawName
                try { name = decodeURIComponent(rawName) } catch (e) { /* 保留原始文件名 */ }
                return { uid: index + '_' + url, url: url, name: name }
            })
        },
        isExtVideo(item) { return /\.(mp4|mov|avi|wmv|mkv|webm|m4v)(\?|$)/i.test(String(item && item.url || '')) },
        isExtImage(item) { return /\.(jpg|jpeg|png|gif|bmp|webp|svg)(\?|$)/i.test(String(item && item.url || '')) },
        buildExtMediaUrl(url) {
            const value = String(url || '')
            if (!value || /^https?:\/\//i.test(value)) return value
            return (value.charAt(0) === '/' ? value : '/' + value)
        },
        openExtMediaPreview(item) { this.extCurrentMedia = item || {}; this.extMediaPreviewShow = true },
        closeExtMediaPreview() { this.extMediaPreviewShow = false; this.extCurrentMedia = {} },
        //获取设备列表
        getList(){
          let data={
            companyId:this.companyId,
            type:this.deviceTreeType,
            id:this.treeId,
            type:this.treeType
          }
            this.get('/DeviceGroup/getDeviceList',data).then((res)=>{
                this.VerifyArr=localStorage.getItem('verifyCodeModule').split(',').map(Number)
                if(res.success){
                    this.dataList = res.result
                    if(this.VirtualDevice.code){  //已经获取了虚拟设备
                      this.dataList.unshift(this.VirtualDevice)
                      if(this.configArr.length==0){
                        this.getConfig()
                      }else{
                        this.sortList()
                      }
                    }else{
                      this.getVirtualDevice();
                    }
                }else{
                    this.$message({
                        message:`${res.message}`,
                        type:'warning'
                    })
                }
            })
        },
      changeCheck(e){
        console.log(this.checkObj)
      },
      // 获取的当前组
      treeClick(node){
          console.log("获取的当前组",node)
          this.treeId = node.id
          this.getList()
      },
      editGroup(){
        let data = {
          companyId:this.companyId,
          id:Number(this.groupId),
          deviceList:this.checkObj.toString()
        }
        console.log(data)
        this.post('/DeviceGroup/setGroup',data).then(res=>{
          if(res.success){
            this.checkObj= []
            this.$store.state.mask = false
            this.editGroupShow = false
            this.showCheck = false
            this.groupId = '0'
            this.$message({
                message: '修改分组成功',
                type: 'success'
            });
          }else{
            this.$message({
                message: `修改分组失败:${res.message}`,
                type: 'warning'
            });
          }
        })
      },
      // 使用模板
      changeMod(e){
        console.log(e)
        let dev = this.list.filter(item=>item.id==e&&item.name!='虚拟设备')[0]
        if(dev){
          this.ruleForm.warn = dev.alarmSet.split(',').map(Number);
          this.ruleForm.attr = dev.propertySet.split(',');
          // console.log(dev)
          let pro = this.allProductData.filter(item=>item.id==dev.productId)[0]
          if(pro){
            for(let item of this.categoryData){
              if(item.children){
                for(let children of item.children){
                    if(children.children){
                      for(let categroy of children.children){
                        if(categroy.id==pro.categoryId){
                          this.ruleForm.productId=[item.id,children.id,categroy.id,pro.id]
                          this.attrShow()
                          this.$forceUpdate()
                        }
                      }
                    }
                }
              }
            }
          }

        }
      },
      // 名称排序
      nameSortList(array){
        var resultArray = array.sort(
            function compareFunction(param1, param2) {
                return param1.name.localeCompare(param2.name,"zh");
            }
        );
        for(let i in resultArray){
          if(resultArray[i].name == '虚拟设备'){
            let item = resultArray.splice(i,1)
            resultArray.unshift(item[0])
          }
        }
        this.list = this.clone(resultArray)
        this.showCodeArr = []
        this.list.map((item)=>{
          this.showCodeArr.push(item.code)
        })
        this.datalist = this.clone(resultArray)
        this.$forceUpdate()
      },
      // 排序弹窗
      paixu(){
        this.pxList = this.clone(this.dataList)
        this.paixuShow=true
        this.$store.state.mask=true
      },

      // 搜索过滤函数
      getArrayByName(val){
        var result = [];
        if(this.list.length < 1){
            return result;
        }
        for (var i in this.list) {
            if ((this.checkStrContain(this.list[i].name,val)||this.checkStrContain(this.list[i].code,val)) && result.length<this.list.length) {
                result.push(this.list[i])
            }
        }
        return result
      },
      // 搜索属性
      searchAttr(){
        // console.log(this.searchAttrVal)
        let searchArr = this.getArrayByName(this.searchAttrVal)
        this.showCodeArr = []
        for(let obj of searchArr){
            this.showCodeArr.push(obj.code)
        }
        // console.log(this.showCodeArr)
        this.$forceUpdate()
      },
      // 模糊搜索=》 匹配方法
      checkStrContain(i, j) {
        if(i.indexOf(j)!=-1){
            return true
        }else if(i.search(new RegExp(j.trim().replace(/([,.+?:()*\[\]^$|{}\\-])/g, '\\$1'), 'i')) !== -1){
          return true
        }else{
            return false
        }
      },
      sortArr(){
        // console.log(this.pxList)
        let arr = []
        for(let obj of this.pxList){
          arr.push(obj.code)
        }
        this.postNoJson("/UserConfig/set",{name:'deviceConfig'+this.companyId,value:arr}).then(res=>{
          if(res.success){
            this.sortList(arr,true)
          }
        })
        this.paixuShow=false
        this.$store.state.mask=false
      },
      // 列表排序
      sortList(arr,isSort){
        if(!arr){arr = this.configArr}
        let list = [],newlist=[];
        // for(let code of arr){
        //   if(code == this.VirtualDevice.code){
        //     list.push(this.VirtualDevice)
        //   }else{
            for(let device of this.dataList){
              if(arr.includes(device.code)){
                list.push(device)
              }else{
                newlist.push(device)
              }
            }
          // }
        // }
        for(let item of newlist){
          list.push(item)
        }
        this.dataList = this.clone(list)
        this.list = this.clone(list)
        if(!isSort){
          this.nameSortList(list)
        }
      },
      // 获取两个下标
      sortend (e, list) {
        const { oldIndex, newIndex } = e;
        this.rearrange(list, oldIndex, newIndex);
      },
      // 处理数组函数
      rearrange (array, oldIndex, newIndex) {
        if (oldIndex > newIndex) {
          array.splice(newIndex, 0, array[oldIndex]);
          array.splice(oldIndex + 1, 1);
        }
        else {
          array.splice(newIndex + 1, 0, array[oldIndex]);
          array.splice(oldIndex, 1);
        }
      },
      // 获取用户配置
      getConfig(){
        if(this.configArr.length==0){   //当前用户配置为空数组
          this.get("/UserConfig/get",{name:'deviceConfig'+this.companyId}).then(res=>{
            if(res.success){
              if(typeof res.result.value == "string"&&res.result.value!="[]"){
                this.configArr = [...new Set(JSON.parse(res.result.value))]
                this.sortList(this.configArr)
              }else{
                let arr = []
                // arr.push(this.VirtualDevice.code)
                for(let obj of this.dataList){
                  arr.push(obj.code)
                }
                // console.log([...new Set(arr)])
                this.configArr = arr
                this.postNoJson("/UserConfig/set",{name:'deviceConfig'+this.companyId,value:arr})
                this.sortList(arr)
              }
            }
          })
        }else{  //直接排序数组
          this.sortList(this.configArr)
        }

      },
        // mqtt消息监听
        mqttMSG (a) {
            // 订阅主题
            console.log('sys/device/' + this.nowObj.code + '/property/push')
            this.client.subscribe('sys/device/' + this.nowObj.code + '/property/push', { qos: 1 }, (error) => {
                if(!error) {
                    // console.log('订阅设备属性成功')
                }else{
                    // console.log('订阅设备属性失败')
                }
            })
            // 接收消息处理
            this.client.on('message', (topic, message) => {
                // this.msg = message.toString()
                console.log(JSON.parse(message.toString()))
                let url = 'sys/device/'+this.nowObj.code+'/property/push'  //主题名
                if(topic == url){
                    let obj = message.toString()
                    obj = JSON.parse(obj).items
                    let arr = [];
                    Object.keys(obj).forEach(function(key){     //将items转为键值对象
                        let devObj ={};
                        devObj.key = key;
                        devObj.value = obj[key];
                        arr.push(devObj);
                    });
                    for(let a of arr){
                        for(let b of this.devData){     //比对标识符，修改value
                            if(a.key == b.identifier){
                                b.value =b.type=='bool'||b.type=='enum'||b.type=='int'? Math.floor(Number(a.value)):b.type=='text'?a.value:Number(a.value)
                            }
                        }
                    }
                    this.$forceUpdate()
                    this.changeColor()
                }
            })
            // 链接异常处理
            this.client.on('error', (error) => {
                // console.log('连接失败:', error)
                // let options={
                //     clientId:this.$store.state.userData.code+'_'+this.$store.state.companyCode,
                //     connectTimeout: 600000,
                //     clean: true
                // }
                // this.client = this.$mqtt.connect(this.$store.state.MQTT_SERVICE,options)    //发起重连
            })
        },
        // mqtt消息监听
        mqttVirtualMSG(code) {
            // 订阅主题
            // console.log(code)
            this.client.subscribe('sys/device/' + code + '/property/push', { qos: 1 }, (error) => {
                if(!error) {
                    // console.log('订阅设备属性成功')
                }else{
                    // console.log('订阅设备属性失败')
                }
            })
            // 接收消息处理
            this.client.on('message', (topic, message) => {
                // console.log('收到来自', topic, '的消息', message.toString())
                // this.msg = message.toString()
                let url = 'sys/device/'+code+'/property/push'  //主题名
                if(topic == url){
                    let obj = message.toString()
                    obj = JSON.parse(obj).items
                    let arr = [];
                    Object.keys(obj).forEach(function(key){     //将items转为键值对象
                        let devObj ={};
                        devObj.key = key;
                        devObj.value = obj[key];
                        arr.push(devObj);
                    });
                    for(let a of arr){
                        for(let b of this.VirtualFuncList){
                            if(a.key==b.code){
                                b.value = a.value
                                // console.log(b.name,a.value)
                                this.$forceUpdate()
                            }
                        }
                    }
                    this.changeVirtualDeviceColor()
                }
            })
            // 链接异常处理
            this.client.on('error', (error) => {
                // console.log('连接失败:', error)
                // let options={
                //     clientId:this.$store.state.userData.code+'_'+this.$store.state.companyCode,
                //     connectTimeout: 600000,
                //     clean: true
                // }
                // this.client = this.$mqtt.connect(this.$store.state.MQTT_SERVICE,options)    //发起重连
            })
        },

        //获取指定企业的虚拟设备
        getVirtualDevice(){
            this.get('/VirtualDevice/get',{companyId:this.companyId}).then((res)=>{
                if(res.success){
                    this.VirtualDevice = res.result
                    this.VirtualDevice.type=1
                    this.VirtualDevice.name="虚拟设备"
                    this.dataList.unshift(this.VirtualDevice)
                    this.getVirtualFuncList()
                }
            }).then(()=>{
                this.getConfig()
            })
        },
        //获取虚拟设备的属性列表
        getVirtualFuncList(){
            if(!this.VirtualDevice.id&&this.VirtualDevice.id!=0){ return }
            let parm = {deviceId:this.VirtualDevice.id,companyId:this.companyId}
            this.get('/VirtualDevice/getPropertyList',parm).then((res)=>{
                if(res.success){
                    res.result.forEach(item=>{
                      item.color="#2c3e50",
                      item.warning=false
                    })
                    this.VirtualFuncList = res.result
                }
            })
        },
        //获取产品类别
        getProduct(){
            this.get('/ProductCategory/getList').then((res)=>{
                this.categoryData=res.result;
                this.productTree(this.categoryData);
            })
        },
        //产品类别转树形数据
        productTree(data){
            /* data = this.clone(data)
            let tree = [],parent,children;
            for(parent of data){
                if(parent.parentId == 0){
                    parent.children = [];
                    tree.push(parent)
                }
            }
            for(children of data){
                for(parent of tree){
                    if(children.parentId == parent.id){
                        parent.children.push(children)
                    }
                }
            } */
            let tree = this.common.arrayToTree(data,'children')
            this.categoryData = tree;
            for(let item of tree){
              if(item.children){
                for(let chi of item.children){
                  if(!chi.children){
                    chi.disabled = true
                  }
                }
              }else{
                  item.disabled = true
              }
            }
            console.log(tree)
            //
            this.getProlist()
        },
        //获取所有产品
        getProlist(){
            this.get('/Product/getList').then((res)=>{
                this.allProductData=res.result;
                let data = this.clone(this.categoryData);
                for(let item of data){
                  if(item.children){
                    for(let children of item.children){
                        if(children.children){
                          for(let categroy of children.children){
                            categroy.children=[]
                            for(let pro of this.allProductData){
                                if(pro.categoryId == categroy.id){
                                    categroy.children.push(pro)
                                }
                            }
                            if(categroy.children.length==0){
                              categroy.disabled = true
                            }
                          }
                        }
                    }
                  }
                }
                console.log(data)
                this.productData = data
            })
        },
        //获取设备日志
        getDeviceLog(){
            let parm={
                deviceId:this.nowObj.id,
                pageNumber:this.pageNumber,
                length:Number(this.pageSize),
                companyId:this.companyId,
                beginDate:this.beginDate==""||this.beginDate==null?null:new Date(this.beginDate).getTime().toString(),
                endDate:this.endDate==""||this.endDate==null?null:new Date(this.endDate).getTime().toString(),
                keyword:this.searchVal,
            }
            this.get('/Device/queryLog',parm).then((res)=>{
                if(res.success){
                    this.totalCount=res.result.totalCount;
                    this.deviceLogList=res.result.data;
                }
            })
        },
        //获取设备维保记录
        getRecord(){
            let parm={
                deviceId:this.nowObj.id,
                pageNumber:this.pageNumber,
                length:Number(this.pageSize),
                companyId:this.companyId
            }
            this.get('/DeviceServiceLog/query',parm).then((res)=>{
                if(res.success){
                    this.totalCount=res.result.totalCount;
                    this.repairRecord=res.result.data;
                }
            })
        },
        //设备状态转换
        deviceState(i){
            switch (i){
                case 1 :
                    return '正常';
                    break;
                case 2 :
                    return '故障';
                    break;
                case 3 :
                    return '离线';
                    break;
                case 4 :
                    return '停用';
                    break;
                case 5 :
                    return '未激活';
                    break;
            }
        },
        //虚拟设备函数转换
        getFunc(i){
            switch (i){
                case 'add' :
                    return '求和';
                    break;
                case 'sub' :
                    return '求差';
                    break;
                case 'max' :
                    return '最大';
                    break;
                case 'min' :
                    return '最小';
                    break;
                case 'avg' :
                    return '平均';
                    break;
            }
        },
        //修改分页size
        setSize(pageObj){
            this.pageSize=pageObj.size;
            if(this.active == 1){
                this.getDeviceLog();
            }else if(this.active == 2){
                this.getRecord();
            }
        },
        //修改页数
        setNum(number){
            this.pageNumber=number;
            if(this.active == 1){
                this.getDeviceLog();
            }else if(this.active == 2){
                this.getRecord();
            }
        },
        //关闭弹窗
        close(name){
            this[name]=false;
            if(name=='addDeviceShow'){
                this.clearVali('addDevice')
            }
            if(this.nowDataShow){
                this.verifyForm.verifyCode = ''
                this.$store.state.mask=true;
                return
            }
            if(name=="editAttrShow"){
                return
            }
            this.ruleForm.inventedAttrArr = this.$options.data().ruleForm.inventedAttrArr
            if(name == 'selectAttrShow'){
                this.oldArr = this.clone(this.ruleForm.attr)
                return
            }else if(name == 'selectWarnShow'){
                this.oldWarn = this.clone(this.ruleForm.warn)
                return
            }else if(name == 'editExtendShow'){
                this.isEditExtend = false;
            }else if(name=='editGroupShow'){
              this.groupId = '0'
            }
            if(this.addDeviceShow){
                return
            }
            this.$store.state.mask=false;
            this.verifyForm.verifyCode = ''
        },
        //动态添加ref
        addref(name,i){
            return name + i
        },
        //打开弹窗
        operate(name,obj,i){
            if(this.VerifyArr.includes(13)&&!this.$store.state.isLook&&this.$store.state.functionList.includes('companyServiceDevice')){
                this.functionShow=true;
                this.$store.state.mask = true
                return
            }
            if(!this.$store.state.functionList.includes('companyServiceDevice')||this.$store.state.isLook){
                return
            }
            if(name == "addDeviceShow" ||  name == 'addExtendShow'){
                this.ruleForm = this.$options.data().ruleForm;
                this.modId=null
                this[name]=true;
                this.$store.state.mask=true;
                this.$refs.addInvAttr.clearValidate()
                this.$refs.addDevice.clearValidate()
                return
            }else if(name == 'selectAttrShow'){
                this[name]=true;
                this.$store.state.mask=true;
                this.oldArr = this.clone(this.ruleForm.attr)
                this.$forceUpdate()  //一言不合就强制刷新一波
                return
            }else if(name=='selectWarnShow'){
                this[name]=true;
                this.$store.state.mask=true;
                this.oldWarn = this.clone(this.ruleForm.warn);
                this.$forceUpdate()  //一言不合就强制刷新一波
                return
            }
            this.nowObj = this.clone(obj);
            this.nowIndex = i;
            this[name]=true;
            this.$store.state.mask=true;
        },
        //关联产品变更时重新获取属性和报警
        attrShow(val,id){
            if(id){
                for(let obj of this.allProductData){
                    //取设备所关联产品编码
                    if(this.ruleForm.productId == obj.id){
                        this.getProAttrData(obj.code)
                        this.getProWarnData(obj.id)
                    }
                }
            }else{
                if(val){
                  this.modId = null
                  this.ruleForm.attr=[]
                  this.ruleForm.warn=[]
                }
                for(let obj of this.allProductData){
                    //取设备所关联产品编码
                    if(this.ruleForm.productId[3] == obj.id){
                        this.getProAttrData(obj.code)
                        this.getProWarnData(obj.id)
                    }
                }
            }
        },
        //获取关联产品的属性列表
        getProAttrData(code){
            this.get('/ProductFeature/get',{code:code}).then((res)=>{
                //json转换
                if(res.success){
                    let proFunction=JSON.parse(res.result)
                    //属性数组
                    this.attrData = this.clone(proFunction.properties)
                    this.allAttr = []
                    for(let attr of this.attrData){
                        //将所有属性的标识符取出
                        this.allAttr.push(attr.identifier)
                    }
                }
            })
        },
        //获取关联产品的报警列表
        getProWarnData(id){
            this.get('/ProductAlarmRule/getList',{productId:id}).then((res)=>{
                if(res.success){
                    this.allWarn=[];
                    this.warnData=[];
                    for(let warn of res.result){
                        let obj = {};
                        obj.id=warn.id
                        obj.name=warn.name
                        this.allWarn.push(obj.id)
                        this.warnData.push(obj)
                    }
                }
            })
        },
        //取消选择属性
        cancal(name){
            this[name]=false;
            if(name == 'selectAttrShow'){
                this.ruleForm.attr = this.clone(this.oldArr);
            }else{
                this.ruleForm.warn = this.clone(this.oldWarn);
            }
            if(this.addDeviceShow){
                return
            }
        },
        //打开选择报警弹窗
        warnShow(){
            if(!this.$store.state.functionList.includes('companyServiceDevice')||this.$store.state.isLook){
                return
            }
            this.$store.state.mask=true;
            this.selectWarnShow = true;
        },
        //删除设备
        removeDevice(){
            this.get('/Device/remove',{id:this.nowObj.id}).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '删除设备成功',
                        type: 'success'
                    });
                    this.configArr.splice(this.configArr.indexOf(this.nowObj.code),1)
                    this.postNoJson("/UserConfig/set",{name:'deviceConfig'+this.companyId,value:this.configArr})
                    this.$store.state.mask = false
                    this.delDeviceShow = false
                    this.getList()
                }else{
                    this.$message({
                        message: `删除设备失败:${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        //启用设备
        enableDevice(){
            this.get('/Device/enable',{id:this.nowObj.id}).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '启用设备成功',
                        type: 'success'
                    });
                    this.list[this.nowIndex].state = 1
                    this.$store.state.mask = false
                    this.enableDeviceShow = false
                }else{
                    this.$message({
                        message: `启用设备失败:${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        //停用设备
        disDevice(){
            this.get('/Device/disable',{id:this.nowObj.id}).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '停用设备成功',
                        type: 'success'
                    });
                    this.list[this.nowIndex].state = 4
                    this.$store.state.mask = false
                    this.disDeviceShow = false
                }else{
                    this.$message({
                        message: `停用设备失败:${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        //删除虚拟设备属性
        delAttribute(){
            let parm = {id:this.nowObj.id}
            this.get('/VirtualDevice/removeProperty',parm).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '删除虚拟设备属性成功',
                        type: 'success'
                    });
                    this.$store.state.mask = false
                    this.delAttributeShow = false
                    this.VirtualFuncList.splice(this.nowIndex,1)
                    this.getVirtualFuncList()
                }else{
                    this.$message({
                        message: `删除虚拟设备属性失败:${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        //查看虚拟设备
        seeFictitious(){
            this.isList=false;
            this.isFictitious=true;
            this.breadcrumbShow=true;
        },
        //返回列表页
        tolist(){
            this.isList = true;
            this.isFictitious=false;
            this.breadcrumbShow = false;
            this.$store.state.mask = false;
            this.editDeviceShow=false;
            this.deviceLogList=[]
            this.ruleForm = this.$options.data().ruleForm;
            this.active=0
        },
        //数字输入框值改变
        inputChange(regObj){
            this.ruleForm[regObj] = this.ruleForm[regObj].replace(/[^\-?\d.]/g,"").replace(/\.{2,}/g,".").replace(".","$#$").replace(/\./g,"").replace("$#$",".").replace(/^\./g, "").replace(/--/g, "-").replace(/[\d]-/g,"");
        },
        //全选属性
        attrAllChange(val) {
            // console.log(val)
            this.ruleForm.attr = val ? this.allAttr : [];
            this.isIndeterminate = false;
        },
        //所选属性变化
        attrCheckedChange(value) {
            value = this.clone(this.ruleForm.attr)
            // console.log(value)
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.allAttr.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.allAttr.length;
            this.$forceUpdate() //一言不合就强制刷新一波
        },
        //复制
        copy(name){
            let copy = this.$refs[name]
            copy.select(); // 选择对象
            document.execCommand('Copy'); // 执行浏览器复制命令
            this.$message({
                type:'success',
                message:'复制成功'
            })
        },
        //全选报警
        warnAllChange(val) {
            this.ruleForm.warn = val ? this.allWarn : [];
            this.isIndeterminateWarn = false;
        },
        //所选报警变化
        warnCheckedChange(value) {
            // console.log(value)
            this.$forceUpdate() //一言不合就强制刷新一波
            value = this.clone(this.ruleForm.warn)
            let checkedCount = value.length;
            this.checkAllWarn = checkedCount === this.allWarn.length;
            this.isIndeterminateWarn = checkedCount > 0 && checkedCount < this.allWarn.length;
        },
        //查看设备
        seeDevice(obj,i){
            if(this.VerifyArr.includes(13)&&!this.$store.state.isLook&&this.$store.state.functionList.includes('companyServiceDevice')){
                this.functionShow=true;
                this.$store.state.mask = true
                return
            }
            this.get('/Device/get',{id:obj.id,companyId:this.companyId}).then((res)=>{
                if(res.success){
                    let obj = res.result
                    this.nowObj = obj;
                    this.nowIndex = i;
                    this.isList=false;
                    this.breadcrumbShow=true;
                    this.editDeviceShow=true;
                    this.ruleForm.deviceName=this.nowObj.name;
                    this.ruleForm.note=this.nowObj.note;
                    this.ruleForm.productId = this.nowObj.productId
                    let attr = this.nowObj.propertySet.split(",")
                    let warn = this.nowObj.alarmSet.split(",").map(Number)
                    if( this.nowObj.extInfo){
                        this.nowObj.extInfo = JSON.parse(this.nowObj.extInfo)
                        if(this.nowObj.extInfo.specsParam){
                            this.nowObj.extInfo.specsParam = JSON.parse(this.nowObj.extInfo.specsParam)
                        }
                        console.log(this.nowObj.extInfo)
                    }
                    this.$set(this.ruleForm,'attr',attr)
                    this.$set(this.ruleForm,'warn',warn)
                    this.attrShow(null,this.nowObj.productId);         //获取设备管理产品属性和报警
                }else{
                    this.$message({
                        type:'warning',
                        message:`${res.message}`
                    })
                }
            })
        },
        getProId(id){
            for(let a of this.productData){
                for(let b of a.children){
                    for(let c of b.children){
                        if(c.id == id){
                            this.ruleForm.productId=[a.id,b.id,c.id]
                            // console.log(this.nowObj.productId)
                            this.$forceUpdate()
                        }
                    }
                }
            }
        },
        //编辑产品页面的按钮点击事件
        setActive(i){
            this.active = i;
            if(this.active == 1){
                this.getDeviceLog();
            }else if(this.active == 2){
                this.getRecord();
            }
        },
        //新建设备
        createDevice(name){
            this.$refs[name].validate((valid) => {
                if(valid){
                    let attr = this.ruleForm.attr.toString();
                    let warn = this.ruleForm.warn.toString();
                    let parm = {
                        id:null,
                        productId:this.ruleForm.productId[3],
                        name:this.ruleForm.deviceName,
                        code:this.ruleForm.deviceCode,
                        secret:null,
                        propertySet:attr,
                        alarmSet:warn,
                        note:this.ruleForm.note,
                        state:null,
                        companyId:this.companyId
                    }
                    this.post('/Device/create',parm).then((res)=>{
                        if(res.success){
                            this.$message({
                                message: '新建设备成功',
                                type: 'success'
                            });
                            this.$store.state.mask = false;
                            this.addDeviceShow = false;
                            this.ruleForm = this.$options.data().ruleForm;
                            this.configArr.push(parm.code)
                            this.postNoJson("/UserConfig/set",{name:'deviceConfig'+this.companyId,value:this.configArr})
                            // let parm = {id:res.result}
                            // this.get('Device/get',parm).then((res)=>{
                            //     if(res.success){
                            //         this.dataList.push(res.result)
                            //     }
                            // })
                            this.getList()
                        }else{
                            this.$message({
                                message: `新建设备失败:${res.message}`,
                                type: 'warning'
                            });
                        }
                    })
                }
            })
        },
        //修改设备
        editDevice(){
            let attr = this.ruleForm.attr.toString();
            let warn = this.ruleForm.warn.toString();
            let parm = {
                id:this.nowObj.id,
                productId:typeof this.ruleForm.productId =="object"?this.ruleForm.productId[3]:this.ruleForm.productId,
                name:this.ruleForm.name,
                code:this.ruleForm.code,
                secret:this.ruleForm.secret,
                propertySet:attr,
                alarmSet:warn,
                note:this.ruleForm.note,
                state:this.ruleForm.state,
                companyId:this.companyId
            }
            this.post('/Device/update',parm).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '修改设备成功',
                        type: 'success'
                    });
                    parm.createdTime = this.nowObj.createdTime
                    this.list[this.nowIndex] = parm;
                    this.nowObj = this.clone(parm);
                    this.setDeviceShow=false;
                    this.$store.state.mask=false;
                }else{
                    this.$message({
                        message: `修改设备失败:${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        //获取虚拟设备的属性列表
        getinvAttr(val,i,isSet){
            //获取设备管理产品的code
            if(!isSet){
                this.ruleForm.inventedAttrArr[i].property = null;
            }
            this.get('/ProductFeature/getByDeviceCode',{code:val}).then((res)=>{   //获取tsl
                if(res.success){
                    let arr = [];
                    let tsl;
                    if(res.result==''){
                        tsl={properties:[]}
                    }else{
                        tsl = JSON.parse(res.result)
                    }
                    let propertyArr;
                    for(let obj of this.list){
                        if(obj.code == val){      //获取对应的设备
                            propertyArr = obj.propertySet.split(',')
                        }
                    }
                    for(let properties of tsl.properties){  //筛选属性
                        for(let property of propertyArr){
                            if(property==properties.identifier){
                                arr.push(properties)
                            }
                        }
                    }
                    this.$set(this.ruleForm.inventedAttrArr[i],'invAttrArr', arr)
                }else{
                    this.$message({
                        type:'warning',
                        message:`${res.message}`
                    })
                }
            }).then(()=>{
                if(this.isEditExtend && this.ruleForm.inventedAttrArr[this.ruleForm.inventedAttrArr.length-1].invAttrArr){
                    this.$store.state.mask=true;
                    this.editExtendShow=true;
                }
            })

        },
        //添加虚拟属性列
        addInvAttrLab(){
            if(this.ruleForm.inventedAttrArr.length>=50){
                this.$message({
                    type:'warning',
                    message:'最多支持50个扩展属性'
                })
                return
            }
            let obj = {deviceCode:null,property:null,invAttrArr:[]}
            this.ruleForm.inventedAttrArr.push(obj);
        },
        //删除虚拟属性列
        delInvAttrLab(i){
            this.ruleForm.inventedAttrArr.splice(i,1);
        },
        //添加扩展属性
        addInvAttr(){
            this.$refs.addInvAttr.validate((valid) => {
                if(valid){
                    let parm ={
                        id:null,
                        name:this.ruleForm.attributeName,
                        code:this.ruleForm.code,
                        deviceId:this.VirtualDevice.id,
                        function:this.ruleForm.function,
                        step:Number(this.ruleForm.step),
                        unit:this.ruleForm.unit,
                        warnUp:this.ruleForm.warnUp==""||this.ruleForm.warnUp==null?null:Number(this.ruleForm.warnUp),
                        warnDown:this.ruleForm.warnDown==""||this.ruleForm.warnDown==null?null:Number(this.ruleForm.warnDown),
                        errorUp:this.ruleForm.errorUp==""||this.ruleForm.errorUp==null?null:Number(this.ruleForm.errorUp),
                        errorDown:this.ruleForm.errorDown==""||this.ruleForm.errorDown==null?null:Number(this.ruleForm.errorDown),
                        properties:[],
                        companyId:this.companyId
                    }
                    for(let obj of this.ruleForm.inventedAttrArr){
                        let item = {}
                        item.deviceCode=obj.deviceCode
                        item.property=obj.property
                        parm.properties.push(item)
                    }
                    if(parm.unit){
                      parm.unitName = this.unitData.filter(i => i.Symbol == parm.unit)[0].Name
                    }
                    this.postNoJson('/VirtualDevice/createProperty',parm).then((res)=>{
                        if(res.success){
                            this.$message({
                                message: '新建扩展属性成功',
                                type: 'success'
                            });
                            let data ={companyId:this.companyId,id:res.result}
                            this.get('/VirtualDevice/getProperty',data).then((response)=>{
                                if(response.success){
                                    let obj = response.result
                                    this.VirtualFuncList.push(obj)
                                }
                            })
                            this.$store.state.mask = false;
                            this.addExtendShow = false;
                            this.ruleForm = this.$options.data().ruleForm;
                        }else{
                            this.$message({
                                message: `新建扩展属性失败:${res.message}`,
                                type: 'warning'
                            });
                        }
                    })
                }
            })
        },
        changeFunc(){
            if(this.ruleForm.function == "sub"){
                //函数为求差时只保留两个属性
                this.ruleForm.inventedAttrArr=this.ruleForm.inventedAttrArr.slice(0,2)
            }
        },
        //编辑扩展属性
        editExtend(obj,i){
            if(this.VerifyArr.includes(13)&&!this.$store.state.isLook&&this.$store.state.functionList.includes('companyServiceDevice')){
                this.functionShow=true;
                this.$store.state.mask = true
                return
            }
            this.get('/VirtualDevice/getProperty',{id:obj.id}).then((res)=>{
                if(res.success){
                    this.nowObj = res.result
                    if(typeof this.nowObj.propertie == 'string'){
                        this.nowObj.propertie = JSON.parse(this.nowObj.propertie)
                    }
                    this.ruleForm.inventedAttrArr = this.clone(this.nowObj.propertie);
                    if(this.ruleForm.inventedAttrArr == undefined){
                        this.ruleForm.inventedAttrArr = JSON.parse(this.nowObj.properties);
                    }
                    this.nowIndex = i;
                    this.ruleForm.attributeName=this.nowObj.name;
                    this.ruleForm.function = this.nowObj.function;
                    this.ruleForm.step = this.nowObj.step;
                    this.ruleForm.unit = this.nowObj.unit;
                    this.ruleForm.code = this.nowObj.code;
                    this.ruleForm.warnUp = this.nowObj.warnUp;
                    this.ruleForm.warnDown = this.nowObj.warnDown;
                    this.ruleForm.errorUp = this.nowObj.errorUp;
                    this.ruleForm.errorDown = this.nowObj.errorDown;
                    for(let index in this.ruleForm.inventedAttrArr){
                        this.getinvAttr(this.ruleForm.inventedAttrArr[index].deviceCode,index,true)
                    }
                    this.isEditExtend=true;
                    this.editExtendShow =true
                    this.$store.state.mask=true
                }else{
                    this.$message({
                        message:`${res.message}`,
                        type:'warning'
                    })
                }
            })
        },
        //修改扩展属性
        editInvAttr(){
            this.$refs.addInvAttr.validate((valid) => {
                if(valid){
                    let parm ={
                        id:this.nowObj.id,
                        name:this.ruleForm.attributeName,
                        deviceId:this.VirtualDevice.id,
                        code:this.ruleForm.code,
                        unit:this.ruleForm.unit,
                        step:Number(this.ruleForm.step),
                        function:this.ruleForm.function,
                        warnUp:this.ruleForm.warnUp==""||this.ruleForm.warnUp==null?null:Number(this.ruleForm.warnUp),
                        warnDown:this.ruleForm.warnDown==""||this.ruleForm.warnDown==null?null:Number(this.ruleForm.warnDown),
                        errorUp:this.ruleForm.errorUp==""||this.ruleForm.errorUp==null?null:Number(this.ruleForm.errorUp),
                        errorDown:this.ruleForm.errorDown==""||this.ruleForm.errorDown==null?null:Number(this.ruleForm.errorDown),
                        properties:[],
                        companyId:this.companyId,
                    }
                    for(let obj of this.ruleForm.inventedAttrArr){
                        let item = {}
                        item.deviceCode=obj.deviceCode
                        item.property=obj.property
                        parm.properties.push(item)
                    }
                    if(parm.unit){
                      parm.unitName = this.unitData.filter(i => i.Symbol == parm.unit)[0].Name
                    }
                    this.postNoJson('/VirtualDevice/updateProperty',parm).then((res)=>{
                        if(res.success){
                            this.$message({
                                message: '修改扩展属性成功',
                                type: 'success'
                            });
                            this.$store.state.mask = false;
                            parm.properties = JSON.stringify(parm.properties)
                            this.VirtualFuncList[this.nowIndex]=parm;
                            this.editExtendShow = false;
                            this.ruleForm = this.$options.data().ruleForm;
                        }else{
                            this.$message({
                                message:`${res.message}`,
                                type:'warning'
                            })
                        }
                    })
                }else{
                    for(let i in this.ruleForm.inventedAttrArr){
                        this.$refs.editInvAttr.validateField(`inventedAttrArr.${i}.property`)
                        this.$refs.editInvAttr.validateField(`inventedAttrArr.${i}.deviceCode`)
                    }
                }
            })
        },
        //查看实时属性
        nowDataClick(obj){
            if(this.VerifyArr.includes(13)&&!this.$store.state.isLook&&this.$store.state.functionList.includes('companyServiceDevice')){
                this.functionShow=true;
                this.$store.state.mask = true
                return
            }
            let id =obj.id;
            this.nowObj = obj;
            let proData = null; //产品属性
            this.valueArr = [];
            this.get('/ProductFeature/getByDeviceCode',{code:obj.code}).then((res)=>{
                if(res.success){
                    let propertyArr = obj.propertySet.split(','),
                    proData = JSON.parse(res.result).properties
                    if(this.cssType==1){    //根据配置的tsl排序进行排序
                      let arr= []
                      for(let properties of proData){
                        if(propertyArr.includes(properties.identifier)){  //
                          properties.type = properties.dataType.type;
                          properties.value=null;
                          properties.color="#2c3e50"
                          properties.warning=false
                          properties.specs = this.clone(properties.dataType.specs);    //属性值
                          if(properties.type == 'enum' || properties.type == 'bool'){ //转换属性值为数组
                              properties.selectData = [];
                              Object.keys(properties.specs).forEach(function(key){
                                  let devObj ={};
                                  devObj.key = key;
                                  devObj.value = properties.specs[key];
                                  properties.selectData.push(devObj);
                              });
                          }
                          arr.push(properties)
                        }
                      }
                      this.devData = arr
                    }else{  //永捷要求的排序
                      let rwarr=[],warr=[],index = 0
                      for(let properties of proData){  //筛选属性
                          for(let property of propertyArr){
                              if(property==properties.identifier){
                                  properties.type = properties.dataType.type;
                                  properties.value=null;
                                  properties.color="#2c3e50"
                                  properties.warning=false
                                  properties.specs = this.clone(properties.dataType.specs);    //属性值
                                  if(properties.type == 'enum' || properties.type == 'bool'){ //转换属性值为数组
                                      properties.selectData = [];
                                      Object.keys(properties.specs).forEach(function(key){
                                          let devObj ={};
                                          devObj.key = key;
                                          devObj.value = properties.specs[key];
                                          properties.selectData.push(devObj);
                                      });
                                  }
                                  if(properties.accessMode=='rw'){
                                      if(properties.type=='bool'){
                                          rwarr.unshift(properties)
                                      }else{
                                          rwarr.push(properties)
                                      }
                                  }else{
                                      if(properties.type=='bool'){
                                          warr.unshift(properties)
                                      }else{
                                          warr.push(properties)
                                      }
                                  }
                              }
                          }
                          if(index == proData.length-1){
                              for(let obj of warr){
                                  rwarr.push(obj)
                              }
                            this.devData = rwarr
                            setTimeout(() => {
                                this.changeColor()
                            },1000)
                          }
                          index++
                      }
                    }

                }else{
                    this.$message({
                        type:'warning',
                        message:`${res.message}`
                    })
                }
            }).then(()=>{
                this.$store.state.mask=true;
                this.nowDataShow=true;
                let that = this
                this.get('/Device/getPropertyValue',{companyId:this.companyId,deviceId:obj.id}).then((res)=>{
                    if(res.success){
                        let arr = res.result
                        for(let obj of this.devData){
                            for(let val of arr){
                                if(obj.identifier==val.code){
                                    obj.value =obj.type=='bool'||obj.type=='enum'||obj.type=='int'? Math.floor(Number(val.value)):obj.type=='text'? val.value:Number(val.value)
                                    if(obj.type == 'date'){
                                        // console.log( obj )
                                    }
                                }
                            }
                        }
                    }else{
                        this.$message({
                            type:'warning',
                            message:`${res.message}`
                        })
                    }
                }).then(()=>{
                    that.mqttMSG(true)
                })
            })
        },
        // 修改颜色
        changeColor(){
            for(let obj of this.devData){
                if(obj.type=='int'||obj.type=='double'||obj.type=='float'){
                    obj.color = '#2c3e50'
                    obj.warning = false
                    let value = Number(obj.value)
                    if(obj.dataType.warnUp){
                        if(value>=Number(obj.dataType.warnUp)){
                            obj.color = '#ff7e00'
                            obj.warning = true
                        }
                    }
                    if(obj.dataType.warnDown){
                        if(value<=Number(obj.dataType.warnDown)){
                            obj.color = '#ff7e00'
                            obj.warning = true
                        }
                    }
                    if(obj.dataType.errorUp){
                        if(value>=Number(obj.dataType.errorUp)){
                            obj.color = '#ff0000'
                            obj.warning = true
                        }
                    }
                    if(obj.dataType.errorDown){
                        if(value<=Number(obj.dataType.errorDown)){
                            obj.color = '#ff0000'
                            obj.warning = true
                        }
                    }
                }
            }
            this.$forceUpdate()
        },
        //修改属性的bool值
        changeBool(obj,val,i){
            if(this.VerifyArr.includes(12)&&!this.$store.state.isLook&&this.$store.state.functionList.includes('companyServiceDevice')){
                this.functionShow=true;
                this.$store.state.mask = true
                return
            }
            let loadbtn = 'boolLoad'+i;
            let btn = 'bool'+i;
            this.$refs[btn][0].style.display = 'none'
            this.$refs[loadbtn][0].$el.style.display = 'block'
            let parm = {
                deviceCode:this.nowObj.code,
                property:obj.identifier,
                value:val,
                companyId:this.companyId
            }
            this.post('/Device/setPropertyValue',parm).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '修改属性成功',
                        type: 'success'
                    });
                }else{
                    this.$message({
                        message: `错误码：${res.result} ${res.message?res.message:''}`,
                        type: 'warning'
                    });
                }
                    this.$refs[btn][0].style.display = 'block'
                    this.$refs[loadbtn][0].$el.style.display = 'none'
            })
        },
        //修改属性的enum值
        changeEnum(val,obj,i){
            if(this.VerifyArr.includes(12)&&!this.$store.state.isLook&&this.$store.state.functionList.includes('companyServiceDevice')){
                this.functionShow=true;
                this.$store.state.mask = true
                return
            }
            let parm = {
                deviceCode:this.nowObj.code,
                property:obj.identifier,
                value:val,
                companyId:this.companyId
            }
            this.post('/Device/setPropertyValue',parm).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '修改属性成功',
                        type: 'success'
                    });
                }else{
                    this.$message({
                        message: `错误码：${res.result} ${res.message?res.message:''}`,
                        type: 'warning'
                    });
                }
            })
        },
        //打开修改属性值弹窗
        editAttr(obj,i){
            if(this.VerifyArr.includes(12)&&!this.$store.state.isLook&&this.$store.state.functionList.includes('companyServiceDevice')){
                this.functionShow=true;
                this.$store.state.mask = true
                return
            }
            this.nowEditAttr = obj;
            // console.log(obj)
            this.nowEditAttrIndex = i;
            this.editAttrShow=true
            this.editAttrForm.editAttrVal = this.nowEditAttr.value
            this.editAttrForm.type=this.nowEditAttr.type
        },
        //修改属性值
        updateAttr(){
            this.$refs.editAttrRef.validate((valid) => {
                if (valid) {
                    let loadbtn = 'editValLoad'+this.nowEditAttrIndex;
                    let btn = 'editVal'+this.nowEditAttrIndex;
                    this.$refs[btn][0].style.display = 'none'
                    // console.log(this.$refs[btn][0])
                    this.$refs[loadbtn][0].$el.style.display = 'block'
                    this.editAttrShow = false;
                    let parm = {
                        deviceCode:this.nowObj.code,
                        property:this.nowEditAttr.identifier,
                        value:this.editAttrForm.editAttrVal,
                        companyId:this.companyId
                    }
                    this.post('/Device/setPropertyValue',parm).then((res)=>{
                        if(res.success){
                            this.$message({
                                message: '修改属性成功',
                                type: 'success'
                            });
                        }else{
                            this.$message({
                                message: `错误码：${res.result} ${res.message?res.message:''}`,
                                type: 'warning'
                            });
                        }
                        this.$refs[loadbtn][0].$el.style.display = 'none'
                        this.$refs[btn][0].style.display = 'inline-block'
                    })
                }
            })
        },
        // 修改设备弹窗
        setDevice(){
            this.ruleForm=this.clone(this.nowObj);
            this.clearVali('setDevice')
            // this.getProId(this.nowObj.productId);
            this.getProCategory(this.nowObj.productId)
            if(this.ruleForm.alarmSet!=''&&this.ruleForm.alarmSet!=null){
                this.ruleForm.warn = this.ruleForm.alarmSet.split(',').map(Number);
            }else{
                this.ruleForm.warn = []
            }
                // console.log(this.ruleForm.warn)
            if(this.ruleForm.propertySet!=''&&this.ruleForm.propertySet!=null){
                this.ruleForm.attr = this.ruleForm.propertySet.split(',');
            }else{
                this.ruleForm.attr=[]
            }
                // console.log(this.ruleForm.attr)
            // this.attrShow(null,this.nowObj.productId);
            this.setDeviceShow=true;
            this.$store.state.mask=true;
        },
        getProCategory(id){
          let pro = this.allProductData.filter(item=>item.id==id)[0]
          if(pro){
            for(let item of this.categoryData){
              if(item.children){
                for(let children of item.children){
                    if(children.children){
                      for(let categroy of children.children){
                        if(categroy.id==pro.categoryId){
                          this.ruleForm.productId=[item.id,children.id,categroy.id,pro.id]
                          this.attrShow()
                          this.$forceUpdate()
                        }
                      }
                    }
                }
              }
            }
          }
        },
        sortPro(property){
            return function(a,b){
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            }
        },
        // 获取验证码
        getCode(){
            this.get('/UserProfile/sendVerifyCode').then((res)=>{
                if(res.success){
                    this.getCodeShow=false
                    this.countdownShow=true
                    const TIME_COUNT = 60;
                    this.$message({
                        message: '验证码发送成功',
                        type: 'success'
                    });
                    if (!this.timer) {
                        this.second = TIME_COUNT;
                        this.show = false;
                        this.timer = setInterval(() => {
                            if (this.second > 0 && this.second <= TIME_COUNT) {
                                this.second--;
                            } else {
                                this.getCodeShow = true;
                                this.countdownShow=false;
                                clearInterval(this.timer);
                                this.timer = null;
                            }
                        }, 1000)
                    }
                }else{
                  this.$message({
                    message: `${res.message}`,
                    type: 'warning'
                  });
                }
            })
        },
        // 用户提权
        Privilege(){
            this.$refs.verifyCode.validate((valid) => {
                if (valid) {
                    this.post('/UserProfile/privilege',{verifyCode:this.verifyForm.verifyCode}).then(res=>{
                        if(res.success){
                            this.$message({
                                message:'提权成功',
                                type:'success'
                            })
                            if(this.nowDataShow){
                                this.VerifyArr.splice(this.VerifyArr.indexOf(12),1)
                                localStorage.setItem('verifyCodeModule',this.VerifyArr)
                            }else{
                                this.VerifyArr.splice(this.VerifyArr.indexOf(13),1)
                                localStorage.setItem('verifyCodeModule',this.VerifyArr)
                                this.$store.state.mask=false
                            }
                            this.functionShow=false
                            this.getCodeShow = true;
                            this.countdownShow=false;
                            clearInterval(this.timer);
                            this.timer = null;
                            this.verifyForm.verifyCode = ''
                        }else{
                            this.$message({
                                message:`${res.message}`,
                                type:'warning'
                            })
                        }
                    })
                }
            })
        },
        // 移除验证结果
        clearVali(name){
            // console.log(name)
            this.$refs[name].clearValidate()
        },
        nowDataVirtualDevice(obj){
            this.nowDataVirtualDeviceShow=true;
            this.$store.state.mask=true;
            this.get('/VirtualDevice/getPropertyValue',{deviceId:obj.id}).then((res)=>{
                if(res.success){
                    // console.log(res.result,this.VirtualFuncList)
                    for(let a of res.result){
                        for(let b of this.VirtualFuncList){
                            if(a.code==b.code){
                                b.value = Number(a.value)
                                this.$forceUpdate()
                            }
                        }
                    }
                }
            }).then(()=>{
                this.changeVirtualDeviceColor()
                this.mqttVirtualMSG(obj.code)
            })
            //
        },
        changeVirtualDeviceColor(){
            for(let obj of this.VirtualFuncList){
                obj.color = '#2c3e50'
                obj.warning = false
                let value = Number(obj.value)
                if(obj.warnUp){
                    if(value>=Number(obj.warnUp)){
                        obj.color = '#ff7e00'
                        obj.warning = true
                    }
                }
                if(obj.warnDown){
                    if(value<=Number(obj.warnDown)){
                        obj.color = '#ff7e00'
                        obj.warning = true
                    }
                }
                if(obj.errorUp){
                    if(value>=Number(obj.errorUp)){
                        obj.color = '#ff0000'
                        obj.warning = true
                    }
                }
                if(obj.errorDown){
                    if(value<=Number(obj.errorDown)){
                        obj.color = '#ff0000'
                        obj.warning = true
                    }
                }
                // console.log(value)
            }
            this.$forceUpdate()
        },
    },
    watch: {
        configArr(){
          // console.log(this.configArr)
        },
        treeType(){
            this.checkObj= []
            this.$store.state.mask = false
            this.editGroupShow = false
            this.showCheck = false
            this.groupId = '0'
        },
        nowDataShow(){
            if(!this.nowDataShow){
                this.devData = []
                let options={
                    onSuccess(){
                        // console.log("退订成功")
                    },
                    onFailure(error){
                        // console.log("退订失败")
                        // console.log(error)
                    }
                }
                let url = 'sys/device/' + this.nowObj.code + '/property/push'
                // console.log('我要退订',url)
                this.client.unsubscribe(url,options)
            }
        },
        nowDataVirtualDeviceShow(){
            if(!this.nowDataVirtualDeviceShow){
                let options={
                    onSuccess(){
                        // console.log("退订成功")
                    },
                    onFailure(error){
                        // console.log("退订失败")
                        // console.log(error)
                    }
                }
                let url = 'sys/device/' + this.VirtualDevice.code + '/property/push'
                // console.log('我要退订',url)
                this.client.unsubscribe(url,options)
            }
        }
    },
}
</script>
<style scoped>
      .px-btn{
          margin-right: 1%;
          padding: 0 15px;
          line-height: 32px;
      }
      .industry>>>.el-input__icon{
        line-height: 34px;
      }

    .popup-paixu{
      height: 702px;
      width: 464px !important;
      overflow: hidden;
      top: 0 !important;
      /* margin-left: -45% !important; */
      text-align: left;
    }
    .popup-editGroup{
      height:226px;
      width: 360px !important;
      overflow: hidden;
      top: 226px !important;
      /* margin-left: -45% !important; */
      text-align: left;
    }
    .icon-box{
      float: right;
      margin-right: 20px;
      padding-top: 5px;
      box-sizing: border-box;
      height: 44px;
      /* width: 80px; */
      cursor: pointer;
    }
    .icon-box img{
      margin: 0 5px;
      width: 14px;
    }
    .sortItem{
      width: 100%;
      border-bottom: 1px solid #f2f2f2;
    }
    .sort-list{
      line-height: 44px;
      font-size: 14px;
      border-bottom: 1px solid #f2f2f2;
      width: 402px;
      background-color: #fff;
    }
    .h-500{
      height: 500px;
      position: relative;
      overflow-y: auto;
      overflow-x: hidden;
    }
    /* 头部面包屑 */
    .breadcrumb{
        font-size: 16px;
        position: relative;
        z-index: 99;
        text-align: left;
        z-index: 1;
    }
    .breadcrumb img{
      width: 18px;
      position: relative;
      top: 2px;
    }
    #deviceList{
        padding:20px 25px;
    }
    .title{
        font-size: 16px;
        text-align: left;
        margin-bottom: 18px;
        margin-left: 16px;
    }
    .content-box{
        padding: 20px 0 0 25px;
        background-color: #fff;
        margin-left: 16px;
        text-align: left;
        min-width: 1330px;
        position: absolute;
        top: 60px;
        right: 25px;
        left: 0;
        bottom: 0;
        z-index: 10;
        /* min-height: 666px; */
    }
    .left-313{
      left: 313px;
    }
    .height-1{

    }
    .height-2{

    }
    .height-3{
        padding-left: 0 !important;
    }
    .list-box{
        margin-top: 16px;
    }
    .scroll{
        overflow: auto;
        width: 99%;
        max-height: 630px;
        box-sizing: border-box;
        border: 1px solid #f2f2f2;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        position: relative;
    }
    /* .scroll>ul:last-child{
        border-bottom: 0;
    } */
    .list-title,.list-details{
        display: flex;
        justify-content: space-around;
        line-height: 44px;
        font-size: 14px;
        color: #636363;
    }
    .list-title{
        background: #eeeeee;
    }
    .list-title li,.list-details li{
        width: 200px;
        margin: 0 20px;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .fictitious li{
        color: #5087e4;
    }
    .fictitious li.note{
        color: #636363;
    }
    .w-18{
        width: 18% !important;
    }
    .list-details:last-child{
        // border-bottom:1px solid #f2f2f2;
    }
    .list-details{
        border-top:1px solid #f2f2f2;
    }
    .w-26{
        width: 26% !important;
    }
    .w-90{
        width: 90px !important;
        margin-right: 40px !important;
    }
    .page-box{
        margin-top: 32px;
    }
    .popup>div{
        position: fixed;
        top: 0%;
        left:50%;
        padding:0 28px;
        box-sizing: border-box;
        margin-left:-289px;
        width: 578px;
        background-color: #fff;
        z-index: 999;
        padding-bottom: 30px;
    }
    .popup-title{
        font-size: 16px;
        line-height: 64px;
        border-bottom: 1px solid #e5e5e5;
        margin-bottom: 12px;
        text-align: left;
    }
    .popup-lab{
        font-size: 14px;
        line-height: 30px;
        margin-bottom: 14px;
    }
    .btn-box{
        margin-top: 28px;
        width: 100%;
        text-align: center;
    }
    .btn-box .el-button{
        padding: 0 34px !important;
        line-height: 34px !important;
        margin: 0 20px;
    }
    .b-32{
        position: absolute;
        bottom: 22px;
        left: 0;
    }
    i.close{
        font-size: 20px;
        float: right;
        margin-top: 24px;
    }
    img.notes{
        position: relative;
        left: 8px;
        top: 3px;
    }
    img.right{
        width: 12px;
        margin: 0 6px;
    }
    .popup-btn-box{
        text-align: center;
        margin-top: 30px;
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 38px;
    }
    .popup-btn-box .el-button{
        padding: 0 34px !important;
        line-height: 34px !important;
        margin: 0 20px;
    }
    .popup-delDevice{
        height: 284px;
    }
    .popup-addDevice{
        height: 628px;
    }
    .p-select{
        text-align: left;
        line-height: 38px;
        font-size: 14px;
    }
    .p-select span{
        margin-right: 25px;
        cursor: pointer;
        color: #5087e4;
    }
    /* .remarks{
        width: 100%;
        height: 78px;
        border: 1px solid #dedede;
        resize: none;
        border-radius: 5px;
        padding:5px;
        box-sizing: border-box;
        line-height: 20px;
        margin-top: 5px;
    } */
    .addDevice-tips{
        text-align: left;
        /* color: #5087e4; */
        font-size: 15px;
    }
    .add-btn{
        float: left;
        line-height: 32px !important;
        padding: 0 15px !important;
        margin-bottom: 18px;
    }
    .function{
        width: 100%;
    }
    .attribute{
        width: 225px;
        float: left;
        margin-right: 10px;
    }
    .popup-addExtend{
        top: -30px !important;
        height: 852px;
    }
    .invAttr-scorll-box{
        height: 170px;
        max-height: 170px;
        overflow: auto;
        background: #f8f8f8;
        border: 1px solid #dcdcdc;
        padding-left: 10px;
        margin-bottom: 10px;
    }
    .add-p{
        cursor: pointer;
        color: #5087e4;
        font-size: 14px;
        text-align: left;
        line-height: 14px;
    }
    .w-100{
        /* margin:16px 0 0 0!important; */
        width: 100% !important;
    }
    .define{
        width: 100%;
    }
    .define span{
        width: 66px;
        display: inline-block;
        margin-left: 8px;
        margin-right: 16px;
        box-sizing: border-box;
        border: 1px solid #dedede;
    }
    .border-red{
        border-right: 8px solid #f00 !important;
    }
    .border-yellow{
        border-right: 8px solid #ffd200 !important;
    }
    .no-border{
        margin-bottom: 0;
        border: 0;
    }
    .popup-select-attribute{
        height: 628px;
    }
    .option-box{
        line-height: 44px;
        border-radius: 5px;
        overflow: hidden;
    }
    .option-box-top{
        text-align: left;
        padding: 0 22px;
        font-size: 14px;
        background-color: #eeeeee;
    }
    .all-check{
        float: right;
    }
    .option-scorll-box{
        max-height: 430px;
        overflow: auto;
    }
    .copy-obj{
        opacity: 0;
        position: fixed;
        top: 0;
        left: 0;
    }
    .data-box{
        width: 100%;
        max-height: 477px;
        overflow: auto;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        flex-wrap: wrap;
    }
    .data-lab{
        width: 48%;
        text-align: left;
        padding: 0 14px;
        line-height: 48px;
        box-sizing: border-box;
        font-size: 14px;
        border: 1px solid #e6e6e6;
        border-bottom: 0;
    }
    .data-box .data-lab:nth-last-child(1),.data-box .data-lab:nth-last-child(2){
        border-bottom: 1px solid #e6e6e6;
    }
    .data-box-left{
        margin-right: 4%;
    }
    .data-btn{
        max-width: 92px;
        margin: 0 12px;
        cursor: pointer;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .attr-name{
        float: left;
        max-width: 35%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .data-span{
        margin: 0 22px 0 12px;
    }
    .data-span.f-l{
        max-width: 145px;
        margin-right: 0 !important;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .active-btn{
        display: inline-block;
        line-height: 14px;
        padding: 6px 12px;
        border-radius: 12px;
        background-color: #5087e4;
        color: #fff;
        position: relative;
        top: 8px;
    }
    .m-r-5{
        margin-right: 5px;
    }
    .popup-nowData{
        width: 950px !important;
        margin-left: -475px !important;
        height: 628px;
    }
    .bg{
        background-color: #fff;
        text-align: center;
        width: 97.15%;
        padding:0 20px;
    }
    .edit-top{
        line-height: 34px;
        text-align: left;
        font-size: 14px;
    }
    .bool>span:last-child{
        margin-right: 5px;
    }
    .b-128{
        position: absolute;
        bottom: 128px;
        left: 0;
    }
    .edit-top p{
        float: left;
        margin-right: 78px;
    }
    .edit-top:first-child{
        margin-right: 0 !important;
    }
    .copy{
        color: #5087e4;
        cursor: pointer;
        margin-left: 20px;
    }
    .edit-btn-box{
        width: 330px;
        border-radius: 5px;
        overflow: hidden;
        cursor: pointer;
        text-align: center;
        margin-top: 12px;
        margin-bottom: 25px;
        background-color: #f1f1f1;
    }
    .edit-btn-box div{
        width: 110px;
        color: #3a3a3a;
        font-size: 14px;
        float: left;
        height: 31px;
        padding-top: 9px;
    }
    .edit-btn-box span{
        display: inline-block;
        line-height: 22px;
        width: 110px;
        box-sizing: border-box;
        border-left: 1px solid #c2c2c2;
    }
    .active{
        background: #5087e4;
        color: #fff !important;
    }
    .active span{
        border: none !important;
    }
    .border-0{
        border: none !important;
    }
    .details{
        background: #fff;
        font-size: 14px;
        color: #606060;
        border: 1px solid #e5e5e5;
        border-radius: 5px;
        margin-bottom: 24px;
    }
    .details span{
        display: inline-block;
        line-height: 44px;
        height: 44px;
        float: left;
    }
    .lab-title{
        background: #eeeeee !important;
        width: 8%;
    }
    .pro-details:last-child{
        border-top: none !important;
    }
    .border-b{
        border-bottom: 1px solid #e5e5e5 !important;
    }
    .lab-note{
        width: 62%;
        text-align: left;
        padding: 0 28px;
        box-sizing: border-box;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .p-select.disable span{
        margin-right: 25px;
        cursor: pointer;
        color: #c2c2c2;
    }
    .add-p.disabled2,.del.disabled2{
        cursor: not-allowed;
        color: #c2c2c2;
    }
    .w-21{
        width: 21%;
    }
    .w-288{
      width: 288px !important;
    }
    .w-22{
        width: 22%;
    }
    .w-25{
        width: 28%;
    }
    .w-33{
        width:33%;
    }
    .h-486{
        height: 90%;
        max-height: 90% !important;
    }
    .edit-top .cascader{
        width: 247px;
    }
    .invAttr-box{
        margin-bottom: 12px;
    }
    .invAttr-title{
        text-align: left;
    }
    .history{
        float: right;
        margin-right: 30px;
        font-size: 14px;
        color: #5087e4;
        cursor: pointer;
    }
    .loading-btn{
        width: 54px !important;
        display: none;
    }
    .popup-editAttr{
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        width: 100%;
        z-index: 999;
        background-color: rgba(0, 0, 0, .4);
    }
    .popup-content{
        position: absolute;
        top: 50%;
        left: 50%;
        height: 220px;
        padding-left:32px ;
        width: 455px;
        background-color: #fff;
        margin-top: -110px;
        margin-left: -227.5px;
    }
    .content-top{
        text-align: left;
        font-size: 14px;
        margin-top: 45px;
    }
    i img.close{
        position: absolute;
        right: 10px;
        top: 12px;
        cursor: pointer;
    }
    .input-box{
        width: 392px;
        position: relative;
        margin-top: 12px;
    }
    .unit{
        position: absolute;
        right: 12px;
        font-size: 14px;
        top: 6px;
    }
    .search-box{
        text-align: left;
        font-size: 15px;
        position: absolute;
        right: 14px;
        top: 67px;
        width: 959px;
    }
    .state-box{
        width: 120px;
        margin-right: 32px;
    }
    .time{
        margin-left: 12px;
        width: 220px;
        margin-right: 25px
    }
    .add-btn{
        float: left;
        line-height: 32px !important;
        padding: 0 15px !important;
    }
    .search{
        float: right;
        width: 75%;
        max-width: 388px;
        min-width: 160px;
        margin-right: 10px;
    }
    .w-40{
        width: 40%;
    }
    .w-20{
        width: 15%;
    }
    .m-r-12{
        margin-right: 12px;
    }
    .m-t-0{
        margin-top: 0 !important;
    }
    .m-t-15{
        margin-top: 15px !important;
    }
    .details-p{
        text-align: left;
        font-size: 15px;
        margin-bottom: 10px;
    }
    .details-p span{
        font-size: 14px;
        color: #5087e4;
        cursor: pointer;
        margin-left: 20px;
    }
    .warning-color{
        color: #ffd200;
    }
    #deviceList .scroll2{
        height: 85%;
        max-height: 85%!important;
    }
    .search{
        float: right;
        width: 388px;
        margin-right: 10px;
    }
    .search-btn{
        float: right;
        margin-right: 20px;
    }
</style>
<style>
    #deviceList .remarks textarea{
        width: 100% !important;
        height: 78px !important;
        border: 1px solid #dedede !important;
        resize: none !important;
        padding:5px !important;
        box-sizing: border-box  !important;
        line-height: 20px !important;
        overflow: hidden !important;
    }
    #deviceList .popup .el-input__inner,#deviceList .input-box .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
    }
    #deviceList .input-box .el-input__inner{
        padding-right:60px !important;
    }
    #deviceList .popup .el-form-item{
        width: 100% !important;
        margin-bottom: 12px !important;
    }
    #deviceList .popup .w-28.el-form-item{
        width: 46% !important;
        margin-bottom: 12px !important;
        float: left;
    }
    #deviceList .popup .el-form-item__label{
        padding: 0 !important;
        color: #2f3a4e !important;
        line-height: 14px !important;
        margin-top: 10px;
        margin-bottom: 5px;
    }
    #deviceList .popup .w-100 .el-form-item__label{
        text-align: left;
        width: 100% !important;
    }
    #deviceList .margin-lab .el-form-item__label{
        margin-bottom: 10px !important;
    }
    #deviceList .popup .el-form-item__content{
        line-height: 34px !important;
    }
    #deviceList .search .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
    }
    #deviceList .el-form-item.m-b-0{
        margin-bottom: 0 !important;
    }
    #deviceList .popup .el-form-item.m-b-10 {
        margin-bottom: 10px !important;
    }
    #deviceList .cascader{
        display: block !important;
    }
    #deviceList .cascader.el-cascader{
        line-height: 36px !important;
    }
    #deviceList .el-cascader-node.in-active-path,.el-cascader-node.is-active{
        font-weight: 500 !important;
    }
    #deviceList .dataTime{
        width: 100%;
    }
    #deviceList .dataTime .el-input__inner{
        padding-left: 30px !important;
    }
    #deviceList .cascader .el-input__icon,#deviceList .function .el-input__icon,#deviceList .attribute .el-input__icon{
        line-height: 32px !important;
    }
    #deviceList .popup .el-form-item.m-b-10 {
        margin-bottom: 10px !important;
    }
    #deviceList .define .el-input__inner{
        border: none !important;
    }
    #deviceList .option-scorll-box .el-checkbox{
        display: block;
        text-align: left;
        padding-left: 10px;
        margin-right: 0;
        border-bottom: 1px solid #e6e6e6;
    }
    #deviceList .option-scorll-box .el-checkbox__input{
        position: absolute;
        left: 448px;
        top: 15px;
    }
    #deviceList .details .el-input__inner{
        border: 0 !important;
        width: 100% !important;
    }
    #deviceList .edit-top .cascader{
        display: inline-block !important;
    }
    #deviceList .edit-top .cascader .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
    }
    #deviceList .edit-top .cascader .el-input__icon{
        height: 32px;
    }
    #deviceList .t-c .el-input__inner{
        text-align: center;
    }
    #deviceList .popup-nowData .enum .el-input__inner{
        border: 0 !important;
        color: #2c3e50;
        text-align: center;
        width: 100px;
    }
    #deviceList .bool .el-button{
        padding: 5px 12px !important;
        line-height: 17px !important;
        border-radius: 12px !important;
    }
    #deviceList .active-btn.el-button{
        border: 0;
        border-color: #8db1ed !important;
        margin-right: 5px;
        float: right;
        margin-top: 4px;
    }
    #deviceList .time .el-input__icon {
        position: relative;
        top: -3px;
    }
    #deviceList .time .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px 0 25px!important;
    }
    #deviceList .search .el-input__icon{
        line-height: 34px !important;
    }
    #deviceList .func-select .el-select{
        width: 100%;
    }
    #deviceList .func-select .el-input__icon{
        line-height: 34px !important;
    }
</style>

<style>
#deviceList .detail-media-grid{display:flex;flex-wrap:wrap;gap:18px;margin:12px 0 20px 160px;}
#deviceList .detail-media-item{position:relative;width:150px;height:115px;border:2px solid #c9c9c9;background:#f6f6f6;box-sizing:border-box;overflow:hidden;display:flex;align-items:center;justify-content:center;cursor:pointer;}
#deviceList .detail-media-item img,#deviceList .detail-media-item video{width:100%;height:100%;object-fit:cover;display:block;}
#deviceList .detail-media-item>i{font-size:40px;color:#159bd5;}
#deviceList .detail-video-play{position:absolute;left:50%;top:50%;width:42px;height:42px;margin:-21px 0 0 -21px;border-radius:50%;background:rgba(0,0,0,.55);color:#fff;display:flex;align-items:center;justify-content:center;pointer-events:none;}
#deviceList .detail-video-play i{color:#fff;font-size:24px;}
#deviceList .detail-media-empty{color:#999;font-size:13px;}
#deviceList .device-media-preview{position:fixed;z-index:5000;left:50%;top:50%;transform:translate(-50%,-50%);width:min(900px,88vw);max-height:90vh;background:#fff;box-shadow:0 4px 24px rgba(0,0,0,.25);}
#deviceList .device-media-preview-title{height:48px;line-height:48px;padding:0 18px;font-size:16px;border-bottom:1px solid #eee;}
#deviceList .device-media-preview-title i{float:right;cursor:pointer;font-size:20px;line-height:48px;}
#deviceList .device-media-preview-content{height:calc(90vh - 112px);min-height:360px;display:flex;align-items:center;justify-content:center;padding:20px;box-sizing:border-box;background:#111;overflow:hidden;}
#deviceList .device-media-preview-image,#deviceList .device-media-preview-video{max-width:100%;max-height:100%;object-fit:contain;}
#deviceList .device-media-preview-video{width:100%;height:100%;}
#deviceList .device-media-preview-unsupported{color:#fff;display:flex;flex-direction:column;align-items:center;gap:12px;}
#deviceList .device-media-preview-footer{padding:12px;text-align:right;}
</style>



// WEBPACK FOOTER //
// src/components/CompanyConsole/Device/deviceList.vue